// @ts-strict-ignore
import * as React from 'react';
import { useMemo } from 'react';
import {
    AllPatternTokens,
    AppNotification,
    CommsChannelAvailableTokens,
    AppNotificationType,
    AppStoreType,
    AppMonitoringHealthMetric,
    AutomationType,
    AutomationHaltPromotePhasedReleaseConditionGroup,
    AutomationAutoStagedRollout,
    CommonNotification,
    IntegrationCapability,
    AzureActiveDirectoryProviderData,
    CommsChannel,
    IntegrationGoogle,
    IntegrationMicrosoftTeams,
    IntegrationProvider,
    IntegrationProviderType,
    MicrosoftTeamsChannel,
    IntegrationSlack,
    MonitoringAutomationConditionType,
    NotificationTriggerConditionType,
    NotificationDestination,
    OrgUser,
    SettingType,
    UserGroup,
    UserGroupId,
    IntegrationType,
    Integration,
    SettingField,
    SettingFieldType,
} from '../../types';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import { shallowEqual, useSelector } from 'react-redux';
import { commsChannelsValidatorFunction, patternTokenSyntaxValidation } from '../../helpers';
import {
    automationAndNotificationSettingsModalContentUsingFormInstance,
    emailValidationRules,
    FieldType,
    filterOptionLabel,
    filterOptionPrefixMatch,
    FormFieldData,
    renderFormFields,
} from '../../helpers/formHelpers';
import { RootState } from '../../reducers/reducers';
import {
    selectAppIntegrations,
    selectAppPlatform,
    selectAppSettings,
    selectAppStoreType,
    selectAutomationsByType,
    selectConnectedCapabilitiesForApp,
    selectJoinedCommsProvidersNamesList,
    selectOrgGroups,
    selectOrgProviders,
    selectOrgProvidersById,
    selectStabilityIntegrations,
} from '../../selectors/selectors';
import { AppComponentProps, AppRouteComponentMatchParams, MonitoringConditionOption } from '../../typescriptHelpers';
import Select from 'antd/lib/select';
import { Link, useHistory, useParams } from 'react-router-dom';
import { createAppSettingsRouteWithSettingType } from '../../helpers/routeHelpers';
import Alert from 'antd/lib/alert';
import Spin from 'antd/lib/spin';
import { globalMessage } from '../../utils/globalMessage';
import Radio from 'antd/lib/radio';
import {
    codeStyle,
    displayTextForAutomationConditionType,
    displayTextForNotificationTriggerConditionType,
    rolloutNounForAppStoreType,
    displayTextForUserChecklistGroup,
    displayUserNameLong,
    iconForAppNotificationId,
} from '../../helpers/displayHelpers';
import Modal from 'antd/lib/modal';
import Drawer from 'antd/lib/drawer';
import ConfigProvider from 'antd/lib/config-provider';
import Divider from 'antd/lib/divider';
import Switch from 'antd/lib/switch';
import Form from 'antd/lib/form';
import { flatten, isEqualWith, partition } from 'lodash';
import { selectAppOrgUsers } from '@/selectors/memoizedSelectors';
import { useError, useIsLoading, useUpdated } from '@/utils/hooks/helpers';
import IntegrationIcon from '../icons/IntegrationIcon';
import Button from 'antd/lib/button';
import PermissionedActionButton from '../HOCs/PermissionedActionButton';
import { RunwayUserAction } from '../../helpers/aclHelpers';
import * as API from '@/api';
import { SendNotificationTestDMRequest } from '@/actions/app';
import Tooltip from 'antd/lib/tooltip';
import Icon, {
    ArrowRightOutlined,
    HistoryOutlined,
    SlidersOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    MailOutlined,
    MessageOutlined,
    CheckOutlined,
    PlusCircleOutlined,
    ReadOutlined,
    SendOutlined,
    SettingOutlined,
    WarningFilled,
} from '@ant-design/icons';
import { antGrey, colorWithAlpha, runwayColors, rwColors, titleStyle } from '@/components/styles/globalStyles';
import { Checkbox, Flex } from 'antd/lib';
import Popover from 'antd/lib/popover';
import Popconfirm from 'antd/lib/popconfirm';
import { PatternTokenHelperTextComponent } from '@/components/appSettings/PatternTokenHelperTextComponent';
import {
    generateHaltPhasedRolloutConditionGroupsField,
    haltConditionGroupsFormValueToConfig,
    HaltPhasedRolloutConditionGroupFormValue,
    NotificationTriggerOption,
} from '../automations/HaltConditionGroups';
import {
    automationConditionsForAutomationType,
    docsLinkForNotificationType,
    getRolloutDaysToPercentageFromAutomation,
} from '../../helpers';
import MarkdownEditor from '../HOCs/MarkdownEditor';
import { getPostableTeamsChannels, TeamsChannelOverrideSelect } from './TeamsChannelOverrideSelect';
import Dropdown from 'antd/lib/dropdown';
import { useUserCanPerformAction } from '@/utils/hooks/useUserCanPerformAction';
import {
    applyStepSelectionChange,
    computeOverrideIndicators,
    deriveOverrideEntries,
    deviationIsNoOp,
    isEmptyFormValue,
    looseFormValueCompare,
    mergeOverrideIntoNotification,
    NotificationDrawerSection,
    overrideConfigFingerprint,
    pendingOverrideDeviation,
    NotificationOverrideEntry,
    NotificationSectionMeta,
    NOTIFICATION_FORM_DEFAULTS,
    SaveNotificationOverridePayload,
    defaultGroupNames,
    isGroupNameTaken,
    isUnsetValue,
    NOTIFICATION_SETTING_GROUP_TRIGGER,
    overriddenFieldsForDeviation,
} from '../../helpers/notificationOverrideHelpers';
import { formFieldsFromSettingFields } from '../../helpers/settingFieldHelpers';
import { useNotificationSettingFields } from '@/utils/hooks/useNotificationSettingFields';
import Input from 'antd/lib/input';
import { EditOutlined, NumberOutlined, TeamOutlined } from '@ant-design/icons';
import { StepNotificationConfigOverride } from '../../types';
import { InlineStepConfigDescription } from '../common/InlineStepConfigDescription';
import {
    selectDestinationInfoByDestinationStepConfigId,
    selectStepConfigDataFromStepGraphs,
} from '../../selectors/selectors';
import { DestinationCounter } from '../appHome/DestinationCounter';
import {
    overrideChannelTooltipContent,
    overrideSettingsTooltipContent,
    overrideMentionTooltipContent,
} from '../appSettings/NotificationStepConfigOverrideRow';
import { Destination } from '@/types/destinations';
import { StepGraphStep } from '@/types/workflow';

export enum MentionType {
    MentionGroups = 'mentionGroups',
    MentionUsers = 'mentionUsers',
    ReleasePilot = 'releasePilot',
    None = 'none',
}

enum SlackOption {
    Mentions = 'mentions',
    Channels = 'channels',
    CustomText = 'customText',
}

const SWITCH_ON_LABEL = 'ON';
const SWITCH_OFF_LABEL = 'OFF';
const SWITCH_THEME = {
    trackPadding: 3,
    trackHeight: 24,
    handleSize: 18,
    innerMinMargin: 9,
    innerMaxMargin: 26,
    trackHeightSM: 20,
    handleSizeSM: 14,
    innerMinMarginSM: 7,
    innerMaxMarginSM: 22,
};

const DRAWER_WIDTH = 920;
const DRAWER_NAV_WIDTH = 208;
const DEFAULT_MAX_ROLLOUT_DAY = 7;

const SECTION_META: Record<
    NotificationDrawerSection,
    { label: string; icon: React.ComponentType<{ style?: React.CSSProperties }> }
> = {
    [NotificationDrawerSection.Settings]: { label: 'Settings', icon: SettingOutlined },
    [NotificationDrawerSection.Channels]: { label: 'Channels', icon: SendOutlined },
    [NotificationDrawerSection.Triggers]: { label: 'Triggers', icon: HistoryOutlined },
};

export interface CommonNotificationSettingsModalProps extends AppComponentProps {
    open: boolean;
    notificationId: string;
    onClose: () => void;
    onAfterClose: () => void;
    actionType: string;

    onSubmit: (formValues: any) => void;
    notification: CommonNotification;
    actionButtonText?: string;
    permissionedActionType?: RunwayUserAction;
    scopeDescription?: React.ReactNode;
    stepOverrides?: NotificationStepOverridesConfig;
}

const NotificationChannelSection: React.FC<{
    title: string;
    icon: React.ReactNode;
    children: React.ReactNode;
    headerAction?: React.ReactNode;
    isChecked?: boolean;
    onToggle?: (checked: boolean) => void;
    disabled?: boolean;
}> = ({ title, icon, children, headerAction, isChecked, onToggle, disabled }) => (
    <div style={{ marginBottom: 16 }}>
        <Flex align="center" justify="space-between" style={{ marginBottom: 16 }}>
            <Space size={16} align="center">
                {onToggle && (
                    <Switch
                        size="small"
                        checked={isChecked}
                        onChange={onToggle}
                        disabled={disabled}
                        checkedChildren={SWITCH_ON_LABEL}
                        unCheckedChildren={SWITCH_OFF_LABEL}
                    />
                )}
                <Flex align="center" gap={8}>
                    {icon}
                    <Text style={{ fontWeight: 600, color: antGrey.grey8, fontSize: 14 }}>{title}</Text>
                </Flex>
            </Space>
            {headerAction}
        </Flex>
        <div
            style={{
                borderRadius: 4,
                padding: 16,
                border: `1px solid ${antGrey.grey5}`,
                backgroundColor: runwayColors.white,
            }}
        >
            {children}
        </div>
    </div>
);

const ChannelOptionToggle: React.FC<{
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    children: React.ReactNode;
}> = ({ label, checked, onChange, disabled, children }) => (
    <div>
        <Checkbox checked={checked} onChange={(e) => onChange(e.target.checked)} disabled={disabled}>
            {label}
        </Checkbox>
        <div style={{ display: checked ? 'block' : 'none', paddingLeft: 24, paddingTop: 12 }}>{children}</div>
    </div>
);

const FormErrorText: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Text style={{ color: runwayColors.statusRed, fontSize: 14 }}>{children}</Text>
);

const createErrorField = (errorMessage: string): FormFieldData => ({
    fieldType: FieldType.Custom,
    renderField: () => <FormErrorText>{errorMessage}</FormErrorText>,
    extraFormItemProps: { style: { marginTop: -8, marginBottom: 16 } },
});

const MentionTypeSelector: React.FC<{
    isDisabled: boolean;
    isSelectionRequired: boolean;
    getNotificationDestinationsState: (form?: any) => { slack: boolean; email: boolean };
}> = ({ isDisabled, isSelectionRequired, getNotificationDestinationsState }) => {
    const form = Form.useFormInstance();
    const { slack: isSlackEnabled } = getNotificationDestinationsState(form);

    return (
        <>
            <Form.Item
                name="mentionType"
                dependencies={['notificationChannels']}
                style={{ marginBottom: 0 }}
                rules={[
                    {
                        validator: (_, mentionType) =>
                            isSelectionRequired && (!mentionType || mentionType === MentionType.None) ?
                                Promise.reject(new Error('Please select who to mention'))
                            :   Promise.resolve(),
                    },
                ]}
                extra="Critical notifications will still mention the release pilot."
            >
                <Radio.Group disabled={isDisabled || !isSlackEnabled}>
                    <Radio value={MentionType.MentionGroups}>User group</Radio>
                    <Radio value={MentionType.MentionUsers}>User</Radio>
                    <Radio value={MentionType.ReleasePilot}>Release pilot</Radio>
                </Radio.Group>
            </Form.Item>
        </>
    );
};

const createDestinationDependentField = (
    base: Omit<FormFieldData, 'renderField'>,
    renderContent: (isSlackEnabled: boolean) => React.ReactNode,
    isDisabled: boolean,
    getDestinationStates: (form?: any) => { slack: boolean; email: boolean },
): FormFieldData => ({
    ...base,
    extraFormItemProps: { ...base.extraFormItemProps, dependencies: ['notificationChannels'] },
    renderField: (data, value, onChange, form) => {
        const { slack: isSlackEnabled } = getDestinationStates(form);
        return renderContent(isSlackEnabled);
    },
});

interface NotificationSettingsSaveButtonProps {
    icon?: React.ReactNode;
    disabled?: boolean;
    disabledReason?: string;
    onSave: () => void;
    loading: boolean;
    actionButtonText?: string;
    permissionedActionType?: RunwayUserAction;
}

const NotificationSettingsSaveButton: React.FC<NotificationSettingsSaveButtonProps> = ({
    icon,
    disabled,
    disabledReason,
    onSave,
    loading,
    actionButtonText,
    permissionedActionType,
}) => {
    const showReasonTooltip = disabled && !!disabledReason;
    // Disabled buttons swallow mouse events, so the wrapper span hosts the tooltip.
    const buttonStyle = showReasonTooltip ? { pointerEvents: 'none' as const } : undefined;
    const button =
        permissionedActionType != null ?
            <PermissionedActionButton
                actionType={permissionedActionType}
                type="primary"
                icon={icon ?? <CheckOutlined />}
                loading={loading}
                disabled={disabled}
                style={buttonStyle}
                onClick={onSave}
            >
                {actionButtonText ?? 'Save'}
            </PermissionedActionButton>
        :   <Button
                type="primary"
                icon={icon ?? <CheckOutlined />}
                loading={loading}
                disabled={disabled}
                style={buttonStyle}
                onClick={onSave}
            >
                {actionButtonText ?? 'Save'}
            </Button>;

    if (showReasonTooltip) {
        return (
            <Tooltip title={disabledReason}>
                <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>{button}</span>
            </Tooltip>
        );
    }
    return button;
};

// The drawer defers rendering its form to a commit after this component mounts, so the pristine
// form values can only be snapshotted from inside the form itself.
const CleanFormSnapshot: React.FC<{ onFormMount: () => void }> = ({ onFormMount }) => {
    React.useEffect(() => {
        onFormMount();
    }, [onFormMount]);
    return null;
};

const withoutEmptyValues = (values: Record<string, unknown>) =>
    Object.keys(values).reduce<Record<string, unknown>>((result, key) => {
        if (!isEmptyFormValue(values[key])) {
            result[key] = values[key];
        }
        return result;
    }, {});

export interface NotificationStepOverridesConfig {
    workflowId?: string;
    overrideActionType: string;
    savedOverrides: StepNotificationConfigOverride[];
    onSaveOverride: (payload: SaveNotificationOverridePayload, loadingId: string) => void;
    onDeleteOverride: (stepConfigIds: string[], loadingId: string) => void;
    initialTarget?: { stepConfigId?: string; createNew?: boolean };
}

interface NotificationSettingsPaneProps {
    orgId: string;
    appId: string;
    form: ReturnType<typeof Form.useForm>[0];
    notification: CommonNotification;
    loadingId: string;
    actionType: string;
    activeSection: NotificationDrawerSection;
    hidden?: boolean;
    showAllSections?: boolean;
    settingsTitleExtra?: React.ReactNode;
    scopeDescription?: React.ReactNode;
    onSubmit: (formValues: Record<string, unknown>) => boolean | void;
    onSaveSuccess: () => void;
    /** Runs after every save, including "Save and send test", which skips onSaveSuccess. */
    onSaved?: () => void;
    onCleanSnapshot?: (values: Record<string, unknown>) => void;
    /** Override panes only */
    inheritedChannelNames?: string[];
    hasUnsavedOverrideEdits?: boolean;
    saveBlockedReason?: string;
    testWorkflowId?: string;
    testStepConfigId?: string;
    onSectionsChange: (sections: NotificationSectionMeta[]) => void;
    onRegisterSave: (save: () => void) => void;
    onValidationError?: (section: NotificationDrawerSection) => void;
    onDirtyChange?: (dirty: boolean) => void;
    onValuesEdited?: () => void;
}

// Generated fields sit in nested groups (a section's wrapper, then each line), so this walks every level
const fieldNamesForSection = (fields: FormFieldData[]): string[] =>
    flatten(
        fields.map((field) =>
            field.fieldType === FieldType.WrappedGroup ? fieldNamesForSection(field.groupedFields ?? []) : [field.name],
        ),
    ).filter((name): name is string => !!name);

const NotificationSettingsPane: React.FC<NotificationSettingsPaneProps> = (props: NotificationSettingsPaneProps) => {
    const form = props.form;
    const appStoreType = useSelector((state: RootState) => selectAppStoreType(state, props.appId));
    const stagedRolloutAutomations = useSelector((state: RootState) =>
        selectAutomationsByType(state, props.appId, AutomationType.AutoStagedRollout),
    ) as AutomationAutoStagedRollout[] | undefined;
    const maxRolloutDay = Math.max(
        DEFAULT_MAX_ROLLOUT_DAY,
        ...(stagedRolloutAutomations ?? []).map(
            (automation) => getRolloutDaysToPercentageFromAutomation(automation)?.length ?? 0,
        ),
    );
    const monitoringMetrics = useSelector(
        (state: RootState) => selectAppSettings(state, props.appId)?.monitoringSettings?.metrics,
    );
    const healthMetricsLink = createAppSettingsRouteWithSettingType(
        props.orgId,
        props.appId,
        SettingType.HealthMetrics,
    );

    const mentionType = Form.useWatch('mentionType', form);
    const selectedNotificationChannels = Form.useWatch('notificationChannels', form);
    const usePrimaryChannels = Form.useWatch('usePrimaryChannels', form) === true;
    const enabledValue = Form.useWatch('enabled', form);
    const isDisabled = enabledValue === false;

    const notificationsProvider = useSelector((state: RootState) => {
        const integrations = selectAppIntegrations(state, props.appId);
        const notificationsIntegration = integrations.find((integration) =>
            integration.capabilities.includes(IntegrationCapability.Notifications),
        );

        if (notificationsIntegration) {
            const providers = selectOrgProviders(state, props.orgId);
            const notificationsProvider = providers.find(
                (provider) => provider.id === notificationsIntegration.providerId,
            );

            return notificationsProvider;
        }

        return null;
    });

    const notification = props.notification;

    const initialNotificationChannels = notification.notificationChannels;

    const [slackChecked, setSlackChecked] = React.useState(
        initialNotificationChannels?.includes(NotificationDestination.Slack) ?? true,
    );
    const [emailChecked, setEmailChecked] = React.useState(
        initialNotificationChannels?.includes(NotificationDestination.Email) || false,
    );

    const [slackOptionsChecked, setSlackOptionsChecked] = React.useState<Record<SlackOption, boolean>>({
        [SlackOption.Mentions]:
            !!notification.mentionUsers?.length ||
            !!notification.mentionGroups?.length ||
            !!notification.mentionReleasePilot,
        [SlackOption.Channels]: (notification.channels?.length ?? 0) > 0,
        [SlackOption.CustomText]: !!notification.customCopy,
    });

    const notificationsIntegration = useSelector((state: RootState) => {
        const integrations = selectAppIntegrations(state, props.appId);
        const notificationsIntegration = integrations.find((integration) =>
            integration.capabilities.includes(IntegrationCapability.Notifications),
        );

        return (
            (notificationsIntegration as IntegrationSlack) || (notificationsIntegration as IntegrationMicrosoftTeams)
        );
    });

    const hasNotificationsIntegration = !!notificationsIntegration;
    const primaryChannels =
        hasNotificationsIntegration ? notificationsIntegration.data?.primaryChannels?.map((chan) => chan.name) : null;

    const updateNotificationSettingSuccess = useUpdated(props.actionType, props.loadingId);
    const updateNotificationSettingError = useError(props.actionType, props.loadingId);

    const handleSaveClick = () => {
        // if disabling a notification, we'll call our submit handler directly
        // so the user isn't blocked by validation errors on fields that no longer matter.
        if (form.getFieldValue('enabled') === false) {
            submitFormValues(form);
        } else {
            form.submit();
        }
    };

    React.useEffect(() => {
        props.onRegisterSave(handleSaveClick);
    });

    const submitFormValues = async (form) => {
        try {
            const isDisabling = form.getFieldValue('enabled') === false;
            const formValues = isDisabling ? form.getFieldsValue() : await form.validateFields();

            if (formValues.conditionGroups) {
                formValues.conditionGroups = haltConditionGroupsFormValueToConfig(
                    formValues.conditionGroups as HaltPhasedRolloutConditionGroupFormValue[],
                    monitoringMetrics,
                );
                delete formValues.conditionGroupsField;
            }

            if (props.onSubmit(formValues) === false) {
                sendAfterSaveRef.current = false;
                setIsSavingBeforeSend(false);
            }
        } catch (error) {
            // hidden sections would swallow the inline validation error
            const firstErrorField = error?.errorFields?.[0];
            if (firstErrorField) {
                const fieldName = Array.isArray(firstErrorField.name) ? firstErrorField.name[0] : firstErrorField.name;
                const failingSection = sections.find((section) =>
                    fieldNamesForSection(section.fields).includes(String(fieldName)),
                )?.key;
                if (failingSection) {
                    props.onValidationError?.(failingSection);
                }
                globalMessage.error(firstErrorField.errors?.[0] ?? 'Please fix the highlighted fields');
                return;
            }
            globalMessage.error(error.message);
        }
    };

    const [isSendTestDMLoading, setIsSendTestDMLoading] = React.useState(false);
    const [isSavingBeforeSend, setIsSavingBeforeSend] = React.useState(false);
    const sendAfterSaveRef = React.useRef(false);
    const pendingTestChannelIdRef = React.useRef<string | undefined>(undefined);
    const [isTestChannelPickerOpen, setIsTestChannelPickerOpen] = React.useState(false);
    const [testChannelId, setTestChannelId] = React.useState<string | undefined>(undefined);
    const cleanFormSnapshotRef = React.useRef<Record<string, unknown> | null>(null);

    const [formIsDirty, setFormIsDirty] = React.useState(false);
    const { onCleanSnapshot } = props;
    const captureCleanFormSnapshot = React.useCallback(() => {
        cleanFormSnapshotRef.current = form.getFieldsValue(true);
        setFormIsDirty(false);
        onCleanSnapshot?.(cleanFormSnapshotRef.current);
    }, [form, onCleanSnapshot]);

    React.useEffect(() => {
        props.onDirtyChange?.(formIsDirty);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formIsDirty]);

    const appUsers = useSelector((state: RootState) => selectAppOrgUsers(state, props.appId));
    const groups = useSelector((state: RootState) => selectOrgGroups(state, props.orgId));

    const connectedCapabilities = useSelector((state: RootState) =>
        selectConnectedCapabilitiesForApp(state, props.appId),
    );
    const stabilityIntegrations = useSelector((state: RootState) => selectStabilityIntegrations(state, props.appId));

    const getNotificationDestinationsState = useMemo(() => {
        return (form?: any) => {
            if (isDisabled) {
                return { slack: false, email: false };
            }
            const currentChannels =
                selectedNotificationChannels ||
                form?.getFieldValue('notificationChannels') ||
                notification.notificationChannels;
            const slack =
                !notification.allowEmails ||
                (currentChannels && currentChannels.includes(NotificationDestination.Slack));
            const email = !!(currentChannels && currentChannels.includes(NotificationDestination.Email));
            return { slack, email };
        };
    }, [selectedNotificationChannels, notification, isDisabled]);

    const handleChannelCheckboxChange = (channel: NotificationDestination, checked: boolean) => {
        if (channel === NotificationDestination.Slack) {
            setSlackChecked(checked);
        } else {
            setEmailChecked(checked);
        }

        const currentChannels = form.getFieldValue('notificationChannels') || [];
        const updatedChannels =
            checked ?
                [...currentChannels.filter((c) => c !== channel), channel]
            :   currentChannels.filter((c) => c !== channel);
        form.setFieldsValue({ notificationChannels: updatedChannels });
    };

    React.useEffect(() => {
        if (updateNotificationSettingSuccess) {
            globalMessage.success('Updated notification settings!');
            captureCleanFormSnapshot();
            props.onSaved?.();
            if (sendAfterSaveRef.current) {
                // Keep the modal open if user clicked "Save and send test DM"
                sendAfterSaveRef.current = false;
                setIsSavingBeforeSend(false);
                sendTest(pendingTestChannelIdRef.current);
            } else {
                props.onSaveSuccess();
            }
        }
    }, [updateNotificationSettingSuccess]);

    React.useEffect(() => {
        if (updateNotificationSettingError) {
            sendAfterSaveRef.current = false;
            setIsSavingBeforeSend(false);
            globalMessage.error(updateNotificationSettingError);
        }
    }, [updateNotificationSettingError]);

    React.useEffect(() => {
        if (!mentionType) {
            return;
        }
        if (mentionType === MentionType.None) {
            form.setFieldsValue({
                [MentionType.MentionUsers]: [],
                [MentionType.MentionGroups]: [],
                mentionReleasePilot: false,
            });
        } else if (mentionType === MentionType.ReleasePilot) {
            form.setFieldsValue({
                [MentionType.MentionUsers]: [],
                [MentionType.MentionGroups]: [],
                mentionReleasePilot: true,
            });
        } else {
            const otherField =
                mentionType === MentionType.MentionGroups ? MentionType.MentionUsers : MentionType.MentionGroups;
            form.setFieldsValue({ [otherField]: [], mentionReleasePilot: false });
        }
    }, [mentionType, form]);

    const auth = useSelector((state: RootState) => state.auth);
    const authCredentials = auth.authCredentials;

    const isSlackIncomingWebhookOverrideConfigured = !!useSelector(
        (state: RootState) => selectAppSettings(state, props.appId)?.isSlackIncomingWebhookOverrideConfigured,
    );

    const sendTest = (channelId?: string) => {
        const requestData: SendNotificationTestDMRequest = {
            orgId: props.orgId,
            appId: props.appId,
            notificationId: notification.id,
            channelId,
            workflowId: props.testWorkflowId,
            stepConfigId: props.testStepConfigId,
        };

        setIsSendTestDMLoading(true);

        API.sendNotificationTestDM(requestData, authCredentials)
            .then(() => {
                globalMessage.success(
                    channelId || isSlackIncomingWebhookOverrideConfigured ? 'Test message sent!' : 'Test DM sent!',
                );
                return;
            })
            .catch((e) => {
                globalMessage.error(e.message);
                return;
            })
            .finally(() => setIsSendTestDMLoading(false));
    };

    const isFormDirty = () => {
        const baseline = cleanFormSnapshotRef.current;
        if (!baseline) {
            return false;
        }
        // Effects reacting to watched fields write empty values for fields that had no entry in the
        // store yet (e.g. mentionUsers when nobody is mentioned), so ignore empty values on both sides.
        return !isEqualWith(
            withoutEmptyValues(baseline),
            withoutEmptyValues(form.getFieldsValue(true)),
            looseFormValueCompare,
        );
    };

    // Unlike onValuesChange, this also sees programmatic setFieldsValue writes (radios, checkboxes, effects).
    const watchedValues = Form.useWatch((values) => values, { form, preserve: true });
    React.useEffect(() => {
        setFormIsDirty(isFormDirty());
        props.onValuesEdited?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchedValues]);

    const handleSaveAndSendTestDM = async () => {
        try {
            await form.validateFields();
        } catch {
            return;
        }
        sendAfterSaveRef.current = true;
        setIsSavingBeforeSend(true);
        handleSaveClick();
    };

    const handleSendTestClick = (channelId?: string) => {
        pendingTestChannelIdRef.current = channelId;
        if (isFormDirty()) {
            if (props.saveBlockedReason) {
                globalMessage.error(props.saveBlockedReason);
                return;
            }
            Modal.confirm({
                title: 'You have unsaved changes',
                content:
                    props.hasUnsavedOverrideEdits ?
                        'Unsaved override changes will be discarded. Save those first if you want to keep them.'
                    :   undefined,
                icon: null,
                maskClosable: true,
                okText: channelId ? 'Save and send test' : 'Save and send test DM',
                cancelText: 'Cancel',
                onOk: handleSaveAndSendTestDM,
            });
        } else {
            sendTest(channelId);
        }
    };

    const showNotificationTestSend = !!notificationsIntegration || isSlackIncomingWebhookOverrideConfigured;
    const testSendUnsupported = !!notification.testSendUnsupported;
    const canUpdateAppSettings = useUserCanPerformAction(
        RunwayUserAction.UAUpdateAppSettings,
        undefined,
        undefined,
        undefined,
        undefined,
        props.appId,
    );
    const showSendTestToChannel =
        !!notificationsIntegration && !isSlackIncomingWebhookOverrideConfigured && !testSendUnsupported;
    const isTeamsNotificationsProvider = notificationsProvider?.type === IntegrationProviderType.AzureActiveDirectory;
    const testChannelOptions =
        isTeamsNotificationsProvider ?
            getPostableTeamsChannels(notificationsProvider.data as AzureActiveDirectoryProviderData).map((channel) => ({
                value: channel.id,
                label: channel.displayName,
            }))
        :   ((notificationsProvider?.data?.availableChannels ?? []) as CommsChannel[]).map((channel) => ({
                value: channel.id,
                label: channel.name,
            }));

    const closeTestChannelPicker = () => {
        setIsTestChannelPickerOpen(false);
        setTestChannelId(undefined);
    };

    const handleSendTestToChannelOk = () => {
        const channelId = testChannelId;
        closeTestChannelPicker();
        handleSendTestClick(channelId);
    };

    const testSendButtonLabel = isSlackIncomingWebhookOverrideConfigured ? 'Send test message' : 'Send test DM';
    const isTestSendInFlight = isSavingBeforeSend || isSendTestDMLoading;
    const isTestSendDisabled = testSendUnsupported || isTestSendInFlight;

    const slackHeaderAction =
        showNotificationTestSend ?
            <Space size={6}>
                <Tooltip
                    title={testSendUnsupported ? "Test sends aren't yet available for this notification." : undefined}
                >
                    {showSendTestToChannel ?
                        <Dropdown.Button
                            size="small"
                            trigger={['click']}
                            disabled={isTestSendDisabled}
                            loading={isTestSendInFlight}
                            onClick={() => handleSendTestClick()}
                            menu={{
                                items: [
                                    {
                                        key: 'channel',
                                        label: 'Send test to channel',
                                        icon: <SendOutlined style={{ color: rwColors.primary }} />,
                                        disabled: !canUpdateAppSettings,
                                    },
                                ],
                                onClick: () => setIsTestChannelPickerOpen(true),
                            }}
                            buttonsRender={([leftButton, rightButton]) => [
                                React.cloneElement(leftButton as React.ReactElement, {
                                    icon: <MessageOutlined style={{ color: rwColors.primary }} />,
                                }),
                                rightButton,
                            ]}
                        >
                            {testSendButtonLabel}
                        </Dropdown.Button>
                    :   <Button
                            size="small"
                            icon={<MessageOutlined style={{ color: rwColors.primary }} />}
                            disabled={isTestSendDisabled}
                            loading={isTestSendInFlight}
                            onClick={() => handleSendTestClick()}
                        >
                            {testSendButtonLabel}
                        </Button>
                    }
                </Tooltip>
                <Modal
                    open={isTestChannelPickerOpen}
                    title="Send test to channel"
                    okText="Send test"
                    okButtonProps={{ disabled: !testChannelId }}
                    onOk={handleSendTestToChannelOk}
                    onCancel={closeTestChannelPicker}
                    destroyOnClose
                >
                    <Select
                        style={{ width: '100%' }}
                        placeholder={isTeamsNotificationsProvider ? 'Select a channel' : 'Select or enter a channel ID'}
                        mode={isTeamsNotificationsProvider ? undefined : 'tags'}
                        maxCount={1}
                        showSearch
                        allowClear
                        notFoundContent={null}
                        optionFilterProp="label"
                        options={testChannelOptions}
                        value={testChannelId}
                        onChange={(value: string | string[]) =>
                            setTestChannelId(Array.isArray(value) ? value[0] : value)
                        }
                    />
                </Modal>
            </Space>
        :   null;

    const commsProviders = useSelector(selectJoinedCommsProvidersNamesList);
    const { settingFieldsByNotificationId, isSettingFieldsError } = useNotificationSettingFields(
        props.orgId,
        props.appId,
    );

    const formFieldSections = notificationSettingFormFieldsForNotification({
        notification,
        settingFields: settingFieldsByNotificationId?.[notification.id],
        provider: notificationsProvider,
        hasNotificationsIntegration,
        userGroups: groups,
        mentionType,
        appUsers,
        primaryChannels,
        inheritedChannelNames: props.inheritedChannelNames,
        selectedNotificationChannels,
        isDisabled,
        getNotificationDestinationsState,
        connectedCapabilities,
        stabilityIntegrations,
        commsProviders,
        appStoreType,
        maxRolloutDay,
        monitoringMetrics,
        healthMetricsLink,
        checkboxActions: {
            slackChecked,
            emailChecked,
            handleChannelCheckboxChange,
            slackHeaderAction,
            usePrimaryChannels,
            onChannelModeChange: (mode) => {
                setSlackOptionsChecked((prev) => ({ ...prev, [SlackOption.Channels]: mode === 'custom' }));
                form.setFieldsValue({
                    ...(mode === 'custom' ? {} : { channels: [] }),
                    ...(props.inheritedChannelNames ? { usePrimaryChannels: mode === 'primary' } : {}),
                });
            },
            slackOptions: {
                [SlackOption.Mentions]: {
                    checked: slackOptionsChecked[SlackOption.Mentions],
                    onChange: (checked) => {
                        setSlackOptionsChecked((prev) => ({ ...prev, [SlackOption.Mentions]: checked }));
                        if (!checked) {
                            form.setFieldsValue({ mentionType: MentionType.None });
                        }
                    },
                },
                [SlackOption.Channels]: {
                    checked: slackOptionsChecked[SlackOption.Channels],
                    onChange: (checked) => {
                        setSlackOptionsChecked((prev) => ({ ...prev, [SlackOption.Channels]: checked }));
                        if (!checked) {
                            form.setFieldsValue({ channels: [] });
                        }
                    },
                },
                [SlackOption.CustomText]: {
                    checked: slackOptionsChecked[SlackOption.CustomText],
                    onChange: (checked) => {
                        setSlackOptionsChecked((prev) => ({ ...prev, [SlackOption.CustomText]: checked }));
                        if (!checked) {
                            form.setFieldsValue({ customCopy: '' });
                        }
                    },
                },
            },
        },
    });
    const notificationDescription = !props.showAllSections && !!notification.info && (
        <Flex
            justify="space-between"
            align="stretch"
            style={{
                backgroundColor: antGrey.grey2,
                border: `1px solid ${antGrey.grey5}`,
                borderRadius: 4,
                padding: '16px 20px',
                marginBottom: 20,
            }}
        >
            <Flex vertical gap={16} style={{ flex: 1, minWidth: 0 }}>
                <Text type="secondary">Runway will send a notification when...</Text>
                <Text style={{ fontSize: 16, color: antGrey.grey8 }}>{notification.info}</Text>
            </Flex>
            <Divider
                type="vertical"
                style={{
                    height: 'auto',
                    alignSelf: 'stretch',
                    margin: '0 20px',
                    borderColor: antGrey.grey5,
                }}
            />
            <Button
                shape="round"
                icon={<ReadOutlined />}
                href={docsLinkForNotificationType(notification.id)}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    flexShrink: 0,
                    alignSelf: 'flex-start',
                    color: runwayColors.primary,
                    borderColor: runwayColors.primaryLight,
                    padding: '2px 12px',
                }}
            >
                Docs <ArrowRightOutlined />
            </Button>
        </Flex>
    );

    const sections = [
        {
            key: NotificationDrawerSection.Settings,
            title: 'Notification settings',
            fields: formFieldSections.settings,
            leading: (
                <>
                    {notificationDescription}
                    {props.scopeDescription}
                    {renderFormFields([formFieldSections.enabled])}
                </>
            ),
        },
        {
            key: NotificationDrawerSection.Channels,
            title: 'Channels',
            fields: formFieldSections.channels,
            leading: null,
        },
        {
            key: NotificationDrawerSection.Triggers,
            title: 'Triggers',
            fields: formFieldSections.triggers,
            leading: null,
        },
    ].filter((section) => section.key === NotificationDrawerSection.Settings || section.fields.length > 0);

    const sectionsMeta = sections.map((section) => ({
        key: section.key,
        fieldNames: fieldNamesForSection(section.fields),
    }));
    const sectionsMetaString = JSON.stringify(sectionsMeta);
    React.useEffect(() => {
        props.onSectionsChange(sectionsMeta);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sectionsMetaString]);

    // The form can't start without every field, or the missing settings would be saved as cleared
    if (!settingFieldsByNotificationId) {
        return isSettingFieldsError ?
                <Alert type="error" showIcon message="Couldn't load the notification settings. Please try again." />
            :   <Spin style={{ display: 'block', margin: '24px auto' }} />;
    }

    const formContent = automationAndNotificationSettingsModalContentUsingFormInstance(
        form,
        [formFieldSections.enabled].concat(...sections.map((section) => section.fields)),
        false,
        submitFormValues,
        <>
            {sections.map((section, index) => {
                // Hidden, not unmounted, so antd keeps their values and validation.
                const visible = !props.hidden && (props.showAllSections || section.key === props.activeSection);
                const titleExtra =
                    section.key === NotificationDrawerSection.Settings ? props.settingsTitleExtra : undefined;
                return (
                    <div key={section.key} style={{ display: visible ? undefined : 'none' }}>
                        {props.showAllSections && index > 0 && (
                            <Divider style={{ margin: '24px 0', borderColor: antGrey.grey5 }} />
                        )}
                        <Flex align="center" justify="space-between" style={{ marginBottom: 24 }}>
                            <Text style={{ ...titleStyle, fontWeight: 400, fontSize: 14 }}>{section.title}</Text>
                            {titleExtra}
                        </Flex>
                        <div className="notification-drawer-section-fields">
                            {section.leading}
                            {renderFormFields(section.fields)}
                        </div>
                    </div>
                );
            })}
            <CleanFormSnapshot onFormMount={captureCleanFormSnapshot} />
        </>,
    );

    return <>{formContent}</>;
};

const OverridePaneContainer: React.FC<{
    entryKey: string;
    orgId: string;
    appId: string;
    appNotification: CommonNotification;
    override: StepNotificationConfigOverride | null;
    loadingId: string;
    actionType: string;
    activeSection: NotificationDrawerSection;
    hidden: boolean;
    onFormReady: (entryKey: string, form: ReturnType<typeof Form.useForm>[0]) => void;
    onRegisterSave: (entryKey: string, save: () => void) => void;
    onValidationError: (entryKey: string, section: NotificationDrawerSection) => void;
    onDirtyChange: (entryKey: string, dirty: boolean) => void;
    onValuesEdited: () => void;
    onSubmit: (formValues: Record<string, unknown>) => boolean;
    onSaved: () => void;
    saveBlockedReason?: string;
    testWorkflowId?: string;
    testStepConfigId?: string;
}> = (props) => {
    const [form] = Form.useForm();
    React.useEffect(() => {
        props.onFormReady(props.entryKey, form);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const seedNotification = React.useMemo(
        () => mergeOverrideIntoNotification(props.appNotification, props.override),
        [props.appNotification, props.override],
    );

    return (
        <NotificationSettingsPane
            orgId={props.orgId}
            appId={props.appId}
            form={form}
            notification={seedNotification}
            loadingId={props.loadingId}
            actionType={props.actionType}
            activeSection={props.activeSection}
            hidden={props.hidden}
            showAllSections
            onSubmit={props.onSubmit}
            onSaveSuccess={() => {}}
            onSaved={props.onSaved}
            saveBlockedReason={props.saveBlockedReason}
            testWorkflowId={props.testWorkflowId}
            testStepConfigId={props.testStepConfigId}
            inheritedChannelNames={(props.appNotification.channels ?? []).map((channel) => channel.name ?? channel.id)}
            onSectionsChange={() => {}}
            onRegisterSave={(save) => props.onRegisterSave(props.entryKey, save)}
            onValidationError={(section) => props.onValidationError(props.entryKey, section)}
            onDirtyChange={(dirty) => props.onDirtyChange(props.entryKey, dirty)}
            onValuesEdited={props.onValuesEdited}
        />
    );
};

const CommonNotificationSettingsModal: React.FC<CommonNotificationSettingsModalProps> = (
    props: CommonNotificationSettingsModalProps,
) => {
    const [form] = Form.useForm();
    const notification = props.notification;
    const appPlatform = useSelector((state: RootState) => selectAppPlatform(state, props.appId));
    const appIntegrations = useSelector((state: RootState) => selectAppIntegrations(state, props.appId));
    const hasNotificationsIntegration = appIntegrations.some((integration) =>
        integration.capabilities.includes(IntegrationCapability.Notifications),
    );
    const { orgIdParam, appIdParam } = useParams<AppRouteComponentMatchParams>();
    const history = useHistory();

    const notificationsIntegrationComponentRoute = createAppSettingsRouteWithSettingType(
        orgIdParam,
        appIdParam,
        SettingType.Integrations,
    );

    const reviewNotificationIds = new Set<AppNotificationType>([
        AppNotificationType.IndividualReview,
        AppNotificationType.DailyUserReviewsDigest,
        AppNotificationType.WeeklyUserReviewsIssuesDigest,
    ]);
    const googlePlayIntegration = appIntegrations.find((integration) => integration.id === IntegrationType.Google) as
        | IntegrationGoogle
        | undefined;
    const showConsoleAppIdHint =
        reviewNotificationIds.has(notification.id as AppNotificationType) &&
        !!googlePlayIntegration &&
        !googlePlayIntegration.data?.consoleAppId;
    const consoleAppIdAlert =
        showConsoleAppIdHint ?
            <Alert
                type="info"
                message={
                    <Text>
                        Add a Play Console app ID in{' '}
                        <Link to={notificationsIntegrationComponentRoute}>Integration settings</Link> to get direct
                        links to reviews.
                    </Text>
                }
                style={{ marginBottom: 24, borderRadius: 4 }}
            />
        :   undefined;

    const [sectionsMeta, setSectionsMeta] = React.useState<NotificationSectionMeta[]>([
        { key: NotificationDrawerSection.Settings, fieldNames: [] },
    ]);
    const sectionKeys = sectionsMeta.map((section) => section.key);
    const [activeSection, setActiveSection] = React.useState(NotificationDrawerSection.Settings);

    const stepOverrides = props.stepOverrides;
    const overridesEnabled = !!stepOverrides && (notification.applicableStepArchetypes?.length ?? 0) > 0;
    const stepGraphStepsMap = useSelector<RootState, Record<string, StepGraphStep>>(
        (state) => selectStepConfigDataFromStepGraphs(state, props.appId),
        shallowEqual,
    );
    const appStoreType = useSelector((state: RootState) => selectAppStoreType(state, props.appId));

    const [activeKey, setActiveKey] = React.useState<string>('app');
    const [overrideEntries, setOverrideEntries] = React.useState<NotificationOverrideEntry[]>([]);
    const [mountedOverrideKeys, setMountedOverrideKeys] = React.useState<string[]>([]);
    const overrideKeyCounterRef = React.useRef(0);
    const overrideEntriesRef = React.useRef(overrideEntries);
    overrideEntriesRef.current = overrideEntries;
    // Membership as sent, so edits made while a save is in flight stay unsaved.
    const sentMembershipRef = React.useRef<Record<string, { stepConfigIds: string[]; groupName: string }>>({});
    const paneFormsRef = React.useRef<Record<string, ReturnType<typeof Form.useForm>[0]>>({});
    // Re-renders once a pane registers its form, since the duplicate check reads the forms from a ref
    const [, setPaneFormsVersion] = React.useState(0);
    const saveFnsRef = React.useRef<Record<string, () => void>>({});
    const [paneDirtyByKey, setPaneDirtyByKey] = React.useState<Record<string, boolean>>({});
    const [overrideFormRevision, setOverrideFormRevision] = React.useState(0);

    const [isEditingGroupName, setIsEditingGroupName] = React.useState(false);
    const [overridePaneGeneration, setOverridePaneGeneration] = React.useState(0);
    const savedOverridesRef = React.useRef(stepOverrides?.savedOverrides);
    savedOverridesRef.current = stepOverrides?.savedOverrides;

    // "Save and send test" keeps the drawer open, so override panes must reseed from the new app-level values.
    const resetOverridePanes = () => {
        if (!overridesEnabled) {
            return;
        }
        sentMembershipRef.current = {};
        paneFormsRef.current = {};
        Object.keys(saveFnsRef.current)
            .filter((key) => key !== 'app')
            .forEach((key) => delete saveFnsRef.current[key]);
        setOverrideEntries(deriveOverrideEntries(savedOverridesRef.current ?? []));
        setMountedOverrideKeys([]);
        setPaneDirtyByKey((prev) => (prev['app'] === undefined ? {} : { app: prev['app'] }));
        setIsEditingGroupName(false);
        setOverridePaneGeneration((generation) => generation + 1);
    };

    const activateOverride = (key: string, section: NotificationDrawerSection = NotificationDrawerSection.Settings) => {
        setActiveKey(key);
        setActiveSection(section);
        setIsEditingGroupName(false);
        setMountedOverrideKeys((prev) => (prev.includes(key) ? prev : [...prev, key]));
    };

    const makeOverrideKey = () => `override-new-${overrideKeyCounterRef.current++}`;
    const makeEmptyOverrideEntry = (): NotificationOverrideEntry => ({
        key: makeOverrideKey(),
        stepConfigIds: [],
        savedStepConfigIds: [],
        groupName: '',
        savedGroupName: '',
        override: null,
        saved: false,
    });

    const handleAddOverride = () => {
        const entry = makeEmptyOverrideEntry();
        setOverrideEntries((prev) => [...prev, entry]);
        activateOverride(entry.key);
    };

    // Derived once per open: re-deriving on store updates would wipe unsaved panes.
    const overridesInitializedRef = React.useRef(false);
    React.useEffect(() => {
        if (!props.open || !overridesEnabled || overridesInitializedRef.current) {
            return;
        }
        overridesInitializedRef.current = true;
        const entries = deriveOverrideEntries(stepOverrides?.savedOverrides ?? []);
        const target = stepOverrides?.initialTarget;
        if (target?.createNew) {
            const entry = makeEmptyOverrideEntry();
            setOverrideEntries([...entries, entry]);
            activateOverride(entry.key);
            return;
        }
        setOverrideEntries(entries);
        if (target?.stepConfigId) {
            const entry = entries.find((candidate) => candidate.stepConfigIds.includes(target.stepConfigId));
            if (entry) {
                activateOverride(entry.key);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open, overridesEnabled]);

    const availableChannelsById = useSelector((state: RootState) => {
        const integrations = selectAppIntegrations(state, props.appId);
        const integration = integrations.find((candidate) =>
            candidate.capabilities.includes(IntegrationCapability.Notifications),
        );
        if (!integration) return {} as Record<string, string>;
        const providersById = selectOrgProvidersById(state, props.orgId);
        const provider = providersById[integration.providerId];
        const channels = provider?.data?.availableChannels ?? [];
        const map: Record<string, string> = {};
        for (const channel of channels as Array<{ id: string; name: string }>) {
            map[channel.id] = channel.name;
        }
        return map;
    });
    const resolveChannelName = (channel: { id: string; name?: string }) =>
        availableChannelsById[channel.id] ?? channel.name ?? channel.id;

    const destinationInfoById = useSelector<RootState, Record<string, Destination>>(
        (state) => selectDestinationInfoByDestinationStepConfigId(state, props.appId),
        shallowEqual,
    );
    const destinationsForEntry = (entry: NotificationOverrideEntry): Destination[] => {
        const destinationIds = new Set<string>();
        entry.stepConfigIds.forEach((stepConfigId) => {
            (stepGraphStepsMap?.[stepConfigId]?.destinationStepConfigIds ?? []).forEach((id) => destinationIds.add(id));
        });
        return Array.from(destinationIds)
            .map((id) => destinationInfoById[id])
            .filter((destination): destination is Destination => destination !== undefined);
    };

    const liveOverrideForEntry = (entry: NotificationOverrideEntry) =>
        stepOverrides?.savedOverrides?.find((override) => entry.savedStepConfigIds.includes(override.stepConfigId)) ??
        entry.override;

    const groupNameDefaults = defaultGroupNames(overrideEntries);
    const overrideEntryLabel = (entry: NotificationOverrideEntry) => {
        if (entry.stepConfigIds.length === 0) {
            return 'New override';
        }
        if (entry.stepConfigIds.length === 1) {
            return stepGraphStepsMap?.[entry.stepConfigIds[0]]?.stepName ?? 'Override';
        }
        return entry.groupName || groupNameDefaults[entry.key] || 'Override group';
    };

    const overrideLoadingId = (key: string) => `${props.notificationId}#${key}`;

    const handleOverrideSubmit =
        (key: string) =>
        (values: Record<string, unknown>): boolean => {
            const entries = overrideEntriesRef.current;
            const entry = entries.find((candidate) => candidate.key === key);
            if (!entry || entry.stepConfigIds.length === 0) {
                globalMessage.error('Select at least one step for the override');
                return false;
            }
            const groupName =
                entry.stepConfigIds.length > 1 ? entry.groupName.trim() || defaultGroupNames(entries)[key] || '' : '';
            if (isGroupNameTaken(entries, key, groupName)) {
                globalMessage.error(`An override group named "${groupName}" already exists`);
                return false;
            }
            const deviation = pendingOverrideDeviation(
                values,
                notification,
                settingFields,
                canonicalSettingKeys,
                appSettingsBaseline,
            );
            if (groupName !== entry.groupName) {
                setOverrideEntries((prev) =>
                    prev.map((candidate) => (candidate.key === key ? { ...candidate, groupName } : candidate)),
                );
            }
            sentMembershipRef.current[key] = { stepConfigIds: [...entry.stepConfigIds], groupName };
            stepOverrides?.onSaveOverride(
                {
                    stepConfigIds: entry.stepConfigIds,
                    deletedStepConfigIds: entry.savedStepConfigIds.filter((id) => !entry.stepConfigIds.includes(id)),
                    groupName,
                    values,
                    channels: deviation.channels,
                    usePrimaryChannels: deviation.sendsToPrimaryChannels,
                    overriddenFields: overriddenFieldsForDeviation(deviation),
                },
                overrideLoadingId(key),
            );
            return true;
        };

    // The saved steps' backend rows now belong to this entry, so no other entry may delete them.
    const handleOverrideSaveSuccess = (key: string) => () => {
        const sent = sentMembershipRef.current[key];
        delete sentMembershipRef.current[key];
        setOverrideEntries((prev) => {
            const savedEntry = prev.find((entry) => entry.key === key);
            if (!savedEntry) {
                return prev;
            }
            const savedStepConfigIds = sent?.stepConfigIds ?? savedEntry.stepConfigIds;
            const savedGroupName = sent?.groupName ?? savedEntry.groupName;
            return prev.map((entry) =>
                entry.key === key ?
                    { ...entry, saved: true, savedStepConfigIds, savedGroupName }
                :   {
                        ...entry,
                        savedStepConfigIds: entry.savedStepConfigIds.filter((id) => !savedStepConfigIds.includes(id)),
                    },
            );
        });
    };

    const handleStepSelectionChange = (selected: string[]) => {
        setOverrideEntries((prev) => applyStepSelectionChange(prev, activeKey, selected));
    };

    const handleGroupNameChange = (value: string) => {
        setOverrideEntries((prev) =>
            prev.map((entry) => (entry.key === activeKey ? { ...entry, groupName: value } : entry)),
        );
    };

    const removeOverrideEntryLocally = (key: string) => {
        setOverrideEntries((prev) => prev.filter((entry) => entry.key !== key));
        setMountedOverrideKeys((prev) => prev.filter((mountedKey) => mountedKey !== key));
        delete paneFormsRef.current[key];
        delete saveFnsRef.current[key];
        setPaneDirtyByKey((prev) => {
            const { [key]: _removed, ...rest } = prev;
            return rest;
        });
        if (activeKey === key) {
            setActiveKey('app');
            setActiveSection(NotificationDrawerSection.Settings);
        }
    };

    const overrideDeleteLoadingId = (key: string) => `${props.notificationId}#${key}#delete`;
    const [pendingDeleteKey, setPendingDeleteKey] = React.useState<string | null>(null);
    const pendingDeleteSuccess = useUpdated(
        stepOverrides?.overrideActionType ?? '',
        pendingDeleteKey ? overrideDeleteLoadingId(pendingDeleteKey) : '',
    );
    const pendingDeleteError = useError(
        stepOverrides?.overrideActionType ?? '',
        pendingDeleteKey ? overrideDeleteLoadingId(pendingDeleteKey) : '',
    );
    const pendingDeleteLoading = useIsLoading(
        stepOverrides?.overrideActionType ?? '',
        pendingDeleteKey ? overrideDeleteLoadingId(pendingDeleteKey) : '',
    );
    React.useEffect(() => {
        if (!pendingDeleteKey) {
            return;
        }
        if (pendingDeleteSuccess) {
            globalMessage.success('Override removed');
            removeOverrideEntryLocally(pendingDeleteKey);
            setPendingDeleteKey(null);
        } else if (pendingDeleteError) {
            globalMessage.error(pendingDeleteError);
            setPendingDeleteKey(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingDeleteSuccess, pendingDeleteError, pendingDeleteKey]);

    const handleRemoveOverride = (key: string) => {
        const entry = overrideEntriesRef.current.find((candidate) => candidate.key === key);
        if (!entry) {
            return;
        }
        if (entry.savedStepConfigIds.length === 0) {
            removeOverrideEntryLocally(key);
            return;
        }
        setPendingDeleteKey(key);
        stepOverrides?.onDeleteOverride(entry.savedStepConfigIds, overrideDeleteLoadingId(key));
    };

    const activeOverrideEntry =
        activeKey === 'app' ? undefined : overrideEntries.find((entry) => entry.key === activeKey);
    const sameIdSet = (a: string[], b: string[]) =>
        a.length === b.length && [...a].sort().every((id, i) => id === [...b].sort()[i]);
    const overrideMembershipDirty = (entry: NotificationOverrideEntry) =>
        !sameIdSet(entry.stepConfigIds, entry.savedStepConfigIds) || entry.groupName !== entry.savedGroupName;
    const canonicalSettingKeys = useSelector(
        (state: RootState) => selectAppSettings(state, props.appId)?.notificationSettingKeys,
    );
    const { settingFieldsByNotificationId } = useNotificationSettingFields(props.orgId, props.appId);
    const settingFields = settingFieldsByNotificationId?.[notification.id] ?? [];
    const monitoringMetricsForComparison = useSelector(
        (state: RootState) => selectAppSettings(state, props.appId)?.monitoringSettings?.metrics,
    );
    const settingsFromRawFormValues = (values: Record<string, unknown>) => {
        const settings = { ...values };
        if (settings.conditionGroups) {
            settings.conditionGroups = haltConditionGroupsFormValueToConfig(
                settings.conditionGroups as HaltPhasedRolloutConditionGroupFormValue[],
                monitoringMetricsForComparison ?? [],
            );
        }
        return settings;
    };
    const [appFormBaseline, setAppFormBaseline] = React.useState<Record<string, unknown> | null>(null);
    const appSettingsBaseline = React.useMemo(
        () => (appFormBaseline ? settingsFromRawFormValues(appFormBaseline) : null),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [appFormBaseline, monitoringMetricsForComparison],
    );
    const { duplicateOfEntry, pendingIsNoOp } = React.useMemo(() => {
        if (!activeOverrideEntry) {
            return { duplicateOfEntry: undefined, pendingIsNoOp: false };
        }
        const activeForm = paneFormsRef.current[activeOverrideEntry.key];
        if (!activeForm) {
            return { duplicateOfEntry: undefined, pendingIsNoOp: false };
        }
        // Registered fields only, like save: the store also holds unrendered fields that are never sent.
        const pendingSettings = settingsFromRawFormValues(activeForm.getFieldsValue() as Record<string, unknown>);
        const pendingDeviation = pendingOverrideDeviation(
            pendingSettings,
            notification,
            settingFields,
            canonicalSettingKeys,
            appSettingsBaseline,
        );
        const pendingFingerprint = JSON.stringify(pendingDeviation);
        return {
            duplicateOfEntry: overrideEntries.find((entry) => {
                if (entry.key === activeOverrideEntry.key) {
                    return false;
                }
                const liveOverride = liveOverrideForEntry(entry);
                return (
                    !!liveOverride &&
                    overrideConfigFingerprint(liveOverride, notification, settingFields, canonicalSettingKeys) ===
                        pendingFingerprint
                );
            }),
            pendingIsNoOp: deviationIsNoOp(pendingDeviation, notification),
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeOverrideEntry,
        overrideEntries,
        overrideFormRevision,
        stepOverrides?.savedOverrides,
        notification,
        canonicalSettingKeys,
        monitoringMetricsForComparison,
        appSettingsBaseline,
    ]);

    const activeGroupName =
        activeOverrideEntry && activeOverrideEntry.stepConfigIds.length > 1 ? activeOverrideEntry.groupName.trim() : '';
    const activeGroupNameTaken =
        !!activeOverrideEntry && isGroupNameTaken(overrideEntries, activeOverrideEntry.key, activeGroupName);

    const overrideSaveDisabledReason = (() => {
        if (!activeOverrideEntry) {
            return undefined;
        }
        if (activeOverrideEntry.stepConfigIds.length === 0) {
            return 'Select at least one step for this override.';
        }
        if (activeGroupNameTaken) {
            return `An override group named "${activeGroupName}" already exists — choose a different name.`;
        }
        const configIsNew =
            activeOverrideEntry.savedStepConfigIds.length === 0 || !!paneDirtyByKey[activeOverrideEntry.key];
        if (duplicateOfEntry && configIsNew) {
            return `Can't save because override configuration matches the "${overrideEntryLabel(duplicateOfEntry)}" override. Add the step(s) to that override instead, or exit and discard.`;
        }
        if (pendingIsNoOp) {
            return "Can't save because override configuration does not differ from non-override configuration. Update configuration to save, or exit and discard.";
        }
        if (!paneDirtyByKey[activeOverrideEntry.key] && !overrideMembershipDirty(activeOverrideEntry)) {
            return 'No changes to save.';
        }
        return undefined;
    })();
    const overrideSaveDisabled = !!overrideSaveDisabledReason;

    const applicableArchetypes = new Set(notification.applicableStepArchetypes ?? []);
    const stepConfigIdsInOtherEntries = new Set(
        flatten(overrideEntries.filter((entry) => entry.key !== activeKey).map((entry) => entry.stepConfigIds)),
    );
    const overrideStepCandidates =
        overridesEnabled ?
            Object.values(stepGraphStepsMap ?? {}).filter(
                (step) =>
                    applicableArchetypes.has(step.archetype) && !stepConfigIdsInOtherEntries.has(step.stepConfigId),
            )
        :   [];

    const appIsLoading = useIsLoading(props.actionType, props.notificationId);
    const overrideIsLoading = useIsLoading(stepOverrides?.overrideActionType ?? '', overrideLoadingId(activeKey));
    const updateNotificationSettingIsLoading = activeKey === 'app' ? appIsLoading : overrideIsLoading;
    const overriddenStepIds = new Set((stepOverrides?.savedOverrides ?? []).map((o) => o.stepConfigId));
    const appLevelSteps =
        overridesEnabled ?
            Object.values(stepGraphStepsMap ?? {}).filter(
                (step) => applicableArchetypes.has(step.archetype) && !overriddenStepIds.has(step.stepConfigId),
            )
        :   [];
    const appliesToTooltip =
        overridesEnabled ?
            <Tooltip
                title={
                    appLevelSteps.length > 0 ?
                        <div>
                            <div>These app-level settings apply to:</div>
                            <ul style={{ margin: '4px 0 0', paddingLeft: 20 }}>
                                {appLevelSteps.map((step) => (
                                    <li key={step.stepConfigId}>{step.stepName}</li>
                                ))}
                            </ul>
                        </div>
                    :   'Every applicable step has an override; these app-level settings currently apply to none.'
                }
            >
                <Text
                    style={{
                        color: antGrey.grey7,
                        textDecoration: 'underline dashed',
                        textUnderlineOffset: 4,
                        cursor: 'default',
                        flexShrink: 0,
                    }}
                >
                    Applies to...
                </Text>
            </Tooltip>
        :   undefined;

    const overridesHaveUnsavedChanges =
        Object.entries(paneDirtyByKey).some(([key, dirty]) => key !== 'app' && dirty) ||
        overrideEntries.some(overrideMembershipDirty);
    const hasUnsavedChanges = !!paneDirtyByKey['app'] || overridesHaveUnsavedChanges;
    const confirmDiscardUnsavedChanges = (content: string, okText: string, onDiscard: () => void) =>
        Modal.confirm({
            title: 'Discard unsaved changes?',
            content,
            okText,
            okButtonProps: { danger: true },
            cancelText: 'Keep editing',
            maskClosable: true,
            onOk: onDiscard,
        });
    const handleDrawerClose = () => {
        if (!hasUnsavedChanges) {
            props.onClose();
            return;
        }
        confirmDiscardUnsavedChanges(
            'You have unsaved changes that will be lost if you close this drawer.',
            'Discard',
            props.onClose,
        );
    };
    const handleSave = () => {
        const save = saveFnsRef.current[activeKey];
        if (activeKey === 'app' && overridesHaveUnsavedChanges) {
            confirmDiscardUnsavedChanges(
                'You have unsaved override changes that will be lost when app-level settings are saved.',
                'Discard and save',
                () => save?.(),
            );
            return;
        }
        save?.();
    };

    return (
        <Drawer
            open={props.open}
            destroyOnClose
            width={DRAWER_WIDTH}
            closeIcon={false}
            onClose={handleDrawerClose}
            afterOpenChange={(open) => {
                if (!open) {
                    form.resetFields();
                    overridesInitializedRef.current = false;
                    overrideKeyCounterRef.current = 0;
                    paneFormsRef.current = {};
                    saveFnsRef.current = {};
                    setOverrideEntries([]);
                    setMountedOverrideKeys([]);
                    setActiveKey('app');
                    setActiveSection(NotificationDrawerSection.Settings);
                    setPendingDeleteKey(null);
                    setPaneDirtyByKey({});
                    props.onAfterClose();
                }
            }}
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, minWidth: 0 }}>
                    <Icon
                        component={iconForAppNotificationId(notification.id)}
                        style={{ fontSize: 24, color: antGrey.grey6, flexShrink: 0 }}
                    />
                    <Text
                        ellipsis={{ tooltip: notification.displayText }}
                        style={{ fontSize: 16, fontWeight: 600, color: antGrey.grey8, minWidth: 0 }}
                    >
                        {notification.displayText}
                    </Text>
                </div>
            }
            extra={
                <Space size={8}>
                    <NotificationSettingsSaveButton
                        icon={activeKey === 'app' ? undefined : <EditOutlined />}
                        disabled={overrideSaveDisabled}
                        disabledReason={overrideSaveDisabledReason}
                        onSave={handleSave}
                        loading={updateNotificationSettingIsLoading}
                        actionButtonText={activeKey === 'app' ? props.actionButtonText : 'Save override'}
                        permissionedActionType={props.permissionedActionType}
                    />
                    {activeOverrideEntry &&
                        (activeOverrideEntry.savedStepConfigIds.length > 0 ?
                            <Popconfirm
                                title="Delete this override?"
                                description="The notification will use app-level defaults for its step(s)."
                                okText="Delete"
                                okButtonProps={{ danger: true }}
                                onConfirm={() => handleRemoveOverride(activeOverrideEntry.key)}
                            >
                                <Tooltip title="Delete override">
                                    <Button
                                        type="text"
                                        danger
                                        icon={<DeleteOutlined style={{ fontSize: 16 }} />}
                                        loading={pendingDeleteLoading}
                                    />
                                </Tooltip>
                            </Popconfirm>
                        :   <Tooltip title="Delete override">
                                <Button
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined style={{ fontSize: 16 }} />}
                                    onClick={() => handleRemoveOverride(activeOverrideEntry.key)}
                                />
                            </Tooltip>)}
                </Space>
            }
            styles={{
                header: { backgroundColor: antGrey.grey3 },
                body: { display: 'flex', paddingTop: 24, paddingBottom: 24, paddingLeft: 0, paddingRight: 0 },
            }}
        >
            <ConfigProvider theme={{ components: { Switch: SWITCH_THEME } }}>
                <Flex
                    vertical
                    style={{
                        width: DRAWER_NAV_WIDTH,
                        flexShrink: 0,
                        borderRight: `1px solid ${antGrey.grey5}`,
                    }}
                >
                    <Flex vertical gap={10} style={{ padding: '0 4px' }}>
                        {sectionKeys.map((sectionKey) => {
                            const isActive = activeKey === 'app' && sectionKey === activeSection;
                            const SectionIcon = SECTION_META[sectionKey].icon;
                            return (
                                <Button
                                    key={sectionKey}
                                    type="text"
                                    block
                                    onClick={() => {
                                        setActiveKey('app');
                                        setActiveSection(sectionKey);
                                    }}
                                    style={{
                                        height: 34,
                                        padding: '0 16px',
                                        justifyContent: 'flex-start',
                                        borderRadius: 4,
                                        backgroundColor: isActive ? colorWithAlpha(rwColors.primary, 0.1) : undefined,
                                    }}
                                >
                                    <Flex align="center" gap={12}>
                                        <SectionIcon
                                            style={{
                                                fontSize: 16,
                                                color: isActive ? runwayColors.primary : antGrey.grey7,
                                            }}
                                        />
                                        <Text
                                            style={{
                                                color: isActive ? runwayColors.primary : antGrey.grey9,
                                                fontWeight: isActive ? 600 : 400,
                                            }}
                                        >
                                            {SECTION_META[sectionKey].label}
                                        </Text>
                                    </Flex>
                                </Button>
                            );
                        })}
                        {overridesEnabled && (
                            <>
                                <Flex
                                    align="center"
                                    justify="space-between"
                                    style={{
                                        marginTop: 16,
                                        height: 34,
                                        padding: '0 16px',
                                        borderRadius: 4,
                                        backgroundColor: antGrey.grey3,
                                    }}
                                >
                                    <Text
                                        style={{ ...titleStyle, fontSize: 12, fontWeight: 400, color: antGrey.grey7 }}
                                    >
                                        Overrides
                                    </Text>
                                    <Tooltip title="Add override">
                                        <Button
                                            type="text"
                                            size="small"
                                            style={{
                                                width: 16,
                                                minWidth: 16,
                                                height: 16,
                                                padding: 0,
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            icon={<PlusCircleOutlined style={{ fontSize: 14, color: antGrey.grey8 }} />}
                                            onClick={handleAddOverride}
                                        />
                                    </Tooltip>
                                </Flex>
                                {overrideEntries.map((entry) => {
                                    const isEntryActive = entry.key === activeKey;
                                    const liveOverride = liveOverrideForEntry(entry);
                                    const indicators =
                                        liveOverride ?
                                            computeOverrideIndicators(liveOverride, notification, settingFields)
                                        :   {
                                                hasChannelOverride: false,
                                                hasMentionOverride: false,
                                                hasTriggerOverride: false,
                                                hasSettingsOverride: false,
                                            };
                                    return (
                                        <div key={entry.key}>
                                            <Button
                                                type="text"
                                                block
                                                onClick={() => activateOverride(entry.key)}
                                                style={{
                                                    height: 28,
                                                    padding: '0 16px',
                                                    borderRadius: 4,
                                                    backgroundColor:
                                                        isEntryActive ?
                                                            colorWithAlpha(rwColors.primary, 0.1)
                                                        :   undefined,
                                                }}
                                            >
                                                <Flex
                                                    align="center"
                                                    justify="space-between"
                                                    gap={8}
                                                    style={{ width: '100%', minWidth: 0 }}
                                                >
                                                    <Flex align="center" gap={8} style={{ minWidth: 0 }}>
                                                        {destinationsForEntry(entry).length > 0 && (
                                                            <Flex
                                                                align="center"
                                                                justify="center"
                                                                style={{ width: 16, height: 16, flexShrink: 0 }}
                                                            >
                                                                <DestinationCounter
                                                                    size={16}
                                                                    destinations={destinationsForEntry(entry)}
                                                                    hideTooltip
                                                                />
                                                            </Flex>
                                                        )}
                                                        <Text
                                                            ellipsis
                                                            style={{
                                                                fontSize: 12,
                                                                color:
                                                                    isEntryActive ?
                                                                        runwayColors.primary
                                                                    :   antGrey.grey9,
                                                                fontWeight: isEntryActive ? 600 : 400,
                                                                minWidth: 0,
                                                            }}
                                                        >
                                                            {overrideEntryLabel(entry)}
                                                        </Text>
                                                    </Flex>
                                                    <Flex align="center" gap={6} flex="none">
                                                        {indicators.hasChannelOverride && (
                                                            <Tooltip
                                                                title={
                                                                    liveOverride ?
                                                                        overrideChannelTooltipContent(
                                                                            liveOverride,
                                                                            notification,
                                                                            resolveChannelName,
                                                                        )
                                                                    :   'Channel override'
                                                                }
                                                            >
                                                                <NumberOutlined
                                                                    style={{
                                                                        fontSize: 12,
                                                                        color:
                                                                            isEntryActive ?
                                                                                runwayColors.primary
                                                                            :   antGrey.grey7,
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        {indicators.hasMentionOverride && (
                                                            <Tooltip
                                                                title={
                                                                    liveOverride ?
                                                                        overrideMentionTooltipContent(
                                                                            liveOverride,
                                                                            notification,
                                                                        )
                                                                    :   'Mention override'
                                                                }
                                                            >
                                                                <TeamOutlined
                                                                    style={{
                                                                        fontSize: 12,
                                                                        color:
                                                                            isEntryActive ?
                                                                                runwayColors.primary
                                                                            :   antGrey.grey7,
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        {indicators.hasTriggerOverride && (
                                                            <Tooltip title="Trigger override">
                                                                <HistoryOutlined
                                                                    style={{
                                                                        fontSize: 12,
                                                                        color:
                                                                            isEntryActive ?
                                                                                runwayColors.primary
                                                                            :   antGrey.grey7,
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        {indicators.hasSettingsOverride && (
                                                            <Tooltip
                                                                title={
                                                                    liveOverride ?
                                                                        overrideSettingsTooltipContent(
                                                                            liveOverride,
                                                                            notification,
                                                                            settingFields,
                                                                        )
                                                                    :   'Settings override'
                                                                }
                                                            >
                                                                <SlidersOutlined
                                                                    style={{
                                                                        fontSize: 12,
                                                                        color:
                                                                            isEntryActive ?
                                                                                runwayColors.primary
                                                                            :   antGrey.grey7,
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </Flex>
                                                </Flex>
                                            </Button>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </Flex>
                </Flex>
                <Flex vertical style={{ flex: 1, minWidth: 0, overflowY: 'auto', padding: '0px 24px 80px' }}>
                    {!hasNotificationsIntegration && (
                        <Alert
                            type="warning"
                            showIcon
                            message="Notifications cannot be sent until a Notifications integration is configured."
                            action={
                                <Button
                                    type="text"
                                    size="small"
                                    style={{
                                        marginLeft: 16,
                                        whiteSpace: 'nowrap',
                                        letterSpacing: titleStyle.letterSpacing,
                                        textTransform: 'uppercase',
                                    }}
                                    onClick={() => history.push(notificationsIntegrationComponentRoute)}
                                >
                                    Integrations <ArrowRightOutlined />
                                </Button>
                            }
                            style={{ marginBottom: 24, borderRadius: 4 }}
                        />
                    )}
                    {consoleAppIdAlert}
                    {activeOverrideEntry && activeSection === NotificationDrawerSection.Settings && (
                        <div>
                            <Flex align="center" justify="space-between" style={{ marginBottom: 24 }}>
                                <Flex align="center" gap={8} flex={1} style={{ minWidth: 0 }}>
                                    {isEditingGroupName && activeOverrideEntry.stepConfigIds.length > 1 ?
                                        <Input
                                            size="small"
                                            autoFocus
                                            value={activeOverrideEntry.groupName}
                                            status={activeGroupNameTaken ? 'error' : undefined}
                                            placeholder={overrideEntryLabel(activeOverrideEntry)}
                                            onChange={(event) => handleGroupNameChange(event.target.value)}
                                            onPressEnter={() => setIsEditingGroupName(false)}
                                            onBlur={() => setIsEditingGroupName(false)}
                                            style={{ flex: 1, minWidth: 0, marginRight: 16 }}
                                        />
                                    :   <>
                                            <Text
                                                ellipsis
                                                style={{ ...titleStyle, fontWeight: 400, fontSize: 16, minWidth: 0 }}
                                            >
                                                {overrideEntryLabel(activeOverrideEntry)}
                                            </Text>
                                            {activeOverrideEntry.stepConfigIds.length > 1 && (
                                                <Tooltip title="Edit group name">
                                                    <Button
                                                        type="text"
                                                        size="small"
                                                        icon={<EditOutlined style={{ color: antGrey.grey7 }} />}
                                                        onClick={() => setIsEditingGroupName(true)}
                                                    />
                                                </Tooltip>
                                            )}
                                        </>
                                    }
                                </Flex>
                            </Flex>
                            {activeGroupNameTaken && (
                                <Text type="danger" style={{ display: 'block', marginBottom: 16 }}>
                                    An override group with this name already exists.
                                </Text>
                            )}
                            <div style={{ marginBottom: 16 }}>
                                <Text
                                    style={{
                                        ...titleStyle,
                                        fontWeight: 400,
                                        fontSize: 14,
                                        marginBottom: 24,
                                        display: 'block',
                                    }}
                                >
                                    Applies to...
                                </Text>
                                <Select
                                    mode="multiple"
                                    value={activeOverrideEntry.stepConfigIds}
                                    onChange={handleStepSelectionChange}
                                    placeholder="Select step(s) for this override"
                                    style={{ width: '100%' }}
                                    options={overrideStepCandidates.map((step) => {
                                        const stepDestinations = (
                                            stepGraphStepsMap?.[step.stepConfigId]?.destinationStepConfigIds ?? []
                                        )
                                            .map((id) => destinationInfoById[id])
                                            .filter((destination): destination is Destination => !!destination);
                                        return {
                                            value: step.stepConfigId,
                                            label: (
                                                <Flex align="center" gap={8}>
                                                    {stepDestinations.length > 0 && (
                                                        <Flex
                                                            align="center"
                                                            justify="center"
                                                            style={{ width: 16, height: 16, flexShrink: 0 }}
                                                        >
                                                            <DestinationCounter
                                                                size={16}
                                                                destinations={stepDestinations}
                                                                hideTooltip
                                                            />
                                                        </Flex>
                                                    )}
                                                    <InlineStepConfigDescription
                                                        stepGraphStep={step}
                                                        platform={appPlatform}
                                                        appStoreType={appStoreType}
                                                        isWorkflowsCIStepEnabled
                                                    />
                                                </Flex>
                                            ),
                                        };
                                    })}
                                />
                            </div>
                            <Divider style={{ margin: '8px 0 24px', borderColor: antGrey.grey5 }} />
                        </div>
                    )}
                    <div>
                        <NotificationSettingsPane
                            orgId={props.orgId}
                            appId={props.appId}
                            form={form}
                            notification={notification}
                            loadingId={props.notificationId}
                            actionType={props.actionType}
                            activeSection={activeSection}
                            hidden={activeKey !== 'app'}
                            settingsTitleExtra={appliesToTooltip}
                            scopeDescription={props.scopeDescription}
                            onSubmit={props.onSubmit}
                            onSaveSuccess={props.onClose}
                            onCleanSnapshot={setAppFormBaseline}
                            hasUnsavedOverrideEdits={overridesHaveUnsavedChanges}
                            onSaved={resetOverridePanes}
                            onSectionsChange={setSectionsMeta}
                            onValidationError={setActiveSection}
                            onRegisterSave={(save) => {
                                saveFnsRef.current['app'] = save;
                            }}
                            onDirtyChange={(dirty) =>
                                setPaneDirtyByKey((prev) => (prev['app'] === dirty ? prev : { ...prev, app: dirty }))
                            }
                        />
                        {overrideEntries
                            .filter((entry) => mountedOverrideKeys.includes(entry.key))
                            .map((entry) => (
                                <OverridePaneContainer
                                    key={`${entry.key}#${overridePaneGeneration}`}
                                    entryKey={entry.key}
                                    orgId={props.orgId}
                                    appId={props.appId}
                                    appNotification={notification}
                                    override={entry.override}
                                    loadingId={overrideLoadingId(entry.key)}
                                    actionType={stepOverrides?.overrideActionType ?? ''}
                                    activeSection={activeSection}
                                    hidden={activeKey !== entry.key}
                                    onFormReady={(key, paneForm) => {
                                        paneFormsRef.current[key] = paneForm;
                                        setPaneFormsVersion((version) => version + 1);
                                    }}
                                    onRegisterSave={(key, save) => {
                                        saveFnsRef.current[key] = save;
                                    }}
                                    onValidationError={(key, section) => activateOverride(key, section)}
                                    onDirtyChange={(key, dirty) =>
                                        setPaneDirtyByKey((prev) =>
                                            prev[key] === dirty ? prev : { ...prev, [key]: dirty },
                                        )
                                    }
                                    onValuesEdited={() => setOverrideFormRevision((revision) => revision + 1)}
                                    onSubmit={handleOverrideSubmit(entry.key)}
                                    onSaved={handleOverrideSaveSuccess(entry.key)}
                                    saveBlockedReason={entry.key === activeKey ? overrideSaveDisabledReason : undefined}
                                    testWorkflowId={stepOverrides?.workflowId}
                                    testStepConfigId={entry.stepConfigIds[0]}
                                />
                            ))}
                    </div>
                </Flex>
            </ConfigProvider>
        </Drawer>
    );
};

export default CommonNotificationSettingsModal;

interface NotificationFormFieldsProps {
    notification: AppNotification;
    settingFields: SettingField[] | undefined;
    provider: IntegrationProvider;
    hasNotificationsIntegration: boolean;
    userGroups: Record<UserGroupId, UserGroup>;
    mentionType?: MentionType;
    appUsers: OrgUser[];
    primaryChannels?: string[] | null;
    inheritedChannelNames?: string[];
    selectedNotificationChannels?: NotificationDestination[];
    isDisabled: boolean;
    getNotificationDestinationsState: (form?: any) => { slack: boolean; email: boolean };
    connectedCapabilities: IntegrationCapability[];
    stabilityIntegrations: Integration[];
    commsProviders: string;
    appStoreType?: AppStoreType;
    maxRolloutDay: number;
    monitoringMetrics?: AppMonitoringHealthMetric[];
    healthMetricsLink?: string;
    checkboxActions?: {
        slackChecked: boolean;
        emailChecked: boolean;
        handleChannelCheckboxChange: (channel: NotificationDestination, checked: boolean) => void;
        slackHeaderAction: React.ReactNode;
        slackOptions: Record<SlackOption, { checked: boolean; onChange: (checked: boolean) => void }>;
        usePrimaryChannels?: boolean;
        onChannelModeChange: (mode: ChannelMode) => void;
    };
}

type ChannelMode = 'default' | 'primary' | 'custom';

const ChannelModeRadio: React.FC<{ value: ChannelMode; label: string; channelNames: string[] }> = ({
    value,
    label,
    channelNames,
}) => (
    <Radio value={value}>
        <Flex align="center" gap={8} wrap="wrap">
            <Text>{label}</Text>
            {channelNames.map((name) => (
                <Text code key={name} style={codeStyle('14px')}>
                    {name}
                </Text>
            ))}
        </Flex>
    </Radio>
);

interface NotificationFormFieldSections {
    enabled: FormFieldData;
    settings: FormFieldData[];
    channels: FormFieldData[];
    triggers: FormFieldData[];
}

const legacyThresholdsAsConditionGroups = (
    notification: AppNotification,
    stabilityIntegrations: Integration[],
): AutomationHaltPromotePhasedReleaseConditionGroup[] => {
    let adoptionThresholds = notification.adoptionThresholds;
    if (!adoptionThresholds && notification.adoptionThreshold && stabilityIntegrations.length === 1) {
        adoptionThresholds = { [stabilityIntegrations[0].installationId]: notification.adoptionThreshold };
    }
    if (!adoptionThresholds && !notification.phasedReleaseDayThreshold) {
        return [];
    }
    return [
        {
            id: 'condition-group-legacy',
            name: 'Group 1',
            adoptionThresholds,
            phasedReleaseDayThreshold: notification.phasedReleaseDayThreshold,
            monitoringConditions: [],
        },
    ];
};

const notificationSettingFormFieldsForNotification = ({
    notification,
    settingFields,
    provider,
    hasNotificationsIntegration,
    userGroups,
    mentionType,
    appUsers,
    primaryChannels,
    inheritedChannelNames,
    isDisabled,
    getNotificationDestinationsState,
    connectedCapabilities,
    stabilityIntegrations,
    commsProviders,
    appStoreType,
    maxRolloutDay,
    monitoringMetrics,
    healthMetricsLink,
    checkboxActions,
}: NotificationFormFieldsProps): NotificationFormFieldSections => {
    const hasProviderAndNotificationIntegration = provider && hasNotificationsIntegration;
    const availableChannels = provider?.data?.availableChannels || [];
    const selectedMentionType =
        notification.mentionUsers?.length ? MentionType.MentionUsers
        : notification.mentionGroups?.length ? MentionType.MentionGroups
        : notification.mentionReleasePilot ? MentionType.ReleasePilot
        : MentionType.None;
    const isMentionedUsersType = mentionType === MentionType.MentionUsers;
    const isMentionedUserGroupsType = mentionType === MentionType.MentionGroups;

    const isSlackProvider = provider?.type === IntegrationProviderType.Slack;
    const notificationsChannelTitle =
        provider?.type === IntegrationProviderType.AzureActiveDirectory ? 'Teams notifications' : 'Slack notifications';

    const slackOptions = checkboxActions?.slackOptions;
    const isSlackToggledOff = notification.allowEmails && checkboxActions?.slackChecked === false;
    const optionsDisabled = isDisabled || isSlackToggledOff;
    const isSlackOptionRequired = (option: SlackOption) => !optionsDisabled && !!slackOptions?.[option].checked;

    const mentionedGroupsField: FormFieldData = createDestinationDependentField(
        {
            label: 'User groups',
            name: MentionType.MentionGroups,
            initialValue: notification.mentionGroups || [],
            fieldType: FieldType.Custom,
            extraFormItemProps: { hidden: !isMentionedUserGroupsType },
            rules: [
                ({ getFieldValue }) => ({
                    validator: (_, value) =>
                        (
                            isSlackOptionRequired(SlackOption.Mentions) &&
                            getFieldValue('mentionType') === MentionType.MentionGroups &&
                            !(value?.length > 0)
                        ) ?
                            Promise.reject(new Error('Select at least one user group'))
                        :   Promise.resolve(),
                }),
            ],
        },
        (isSlackEnabled) => (
            <Select
                disabled={isDisabled || !isSlackEnabled}
                mode="multiple"
                allowClear
                placeholder="Select a user group/groups"
                filterOption={filterOptionPrefixMatch}
            >
                {Object.keys(userGroups)
                    .filter((groupId) => !userGroups[groupId]?.disabled)
                    .map((groupId, index) => (
                        <Select.Option key={index} value={groupId}>
                            {displayTextForUserChecklistGroup(userGroups[groupId])}
                        </Select.Option>
                    ))}
            </Select>
        ),
        isDisabled,
        getNotificationDestinationsState,
    );

    const mentionedUsersField: FormFieldData = createDestinationDependentField(
        {
            label: 'Users',
            name: MentionType.MentionUsers,
            initialValue: notification.mentionUsers || [],
            fieldType: FieldType.Custom,
            extraFormItemProps: { hidden: !isMentionedUsersType },
            rules: [
                ({ getFieldValue }) => ({
                    validator: (_, value) =>
                        (
                            isSlackOptionRequired(SlackOption.Mentions) &&
                            getFieldValue('mentionType') === MentionType.MentionUsers &&
                            !(value?.length > 0)
                        ) ?
                            Promise.reject(new Error('Select at least one user'))
                        :   Promise.resolve(),
                }),
            ],
        },
        (isSlackEnabled) => (
            <Select
                disabled={isDisabled || !isSlackEnabled}
                allowClear
                mode="multiple"
                maxTagCount={'responsive'}
                placeholder="Select a user/users"
            >
                {appUsers.map((user, index) => (
                    <Select.Option value={user.email} key={index}>
                        {displayUserNameLong(user)}
                    </Select.Option>
                ))}
            </Select>
        ),
        isDisabled,
        getNotificationDestinationsState,
    );
    const enabledField: FormFieldData = {
        label: 'Enabled',
        name: 'enabled',
        initialValue: notification.enabled,
        fieldType: FieldType.Switch,
        switchOnText: SWITCH_ON_LABEL,
        switchOffText: SWITCH_OFF_LABEL,
        rules: [{ required: true }],
        extraFormItemProps: { required: false },
        style: { marginTop: 0, marginBottom: 24 },
    };
    const fields: FormFieldData[] = [];
    const triggerFields: FormFieldData[] = [];
    const channelFields: FormFieldData[] = [];

    const notificationSettingFields = (settingFields ?? []).map((settingField) =>
        withNotificationCurrentValue(settingField, notification),
    );
    const [triggerSettingFields, otherSettingFields] = partition(
        notificationSettingFields,
        (settingField) => settingField.group === NOTIFICATION_SETTING_GROUP_TRIGGER,
    );
    fields.push(
        ...withNotificationFieldsDisabled(
            formFieldsFromSettingFields(otherSettingFields, undefined, (settingField) =>
                resolveNotificationFormField(settingField, {
                    notification,
                    connectedCapabilities,
                    stabilityIntegrations,
                    appStoreType,
                    maxRolloutDay,
                    monitoringMetrics,
                    healthMetricsLink,
                }),
            ),
            isDisabled,
        ),
    );
    triggerFields.push(
        ...withNotificationFieldsDisabled(
            formFieldsFromSettingFields(triggerSettingFields, undefined, (settingField) =>
                resolveNotificationFormField(settingField, {
                    notification,
                    connectedCapabilities,
                    stabilityIntegrations,
                    appStoreType,
                    maxRolloutDay,
                    monitoringMetrics,
                    healthMetricsLink,
                }),
            ),
            isDisabled,
        ),
    );

    if (notification.allowEmails) {
        channelFields.push(
            {
                name: 'notificationChannels',
                initialValue: notification.notificationChannels || [...NOTIFICATION_FORM_DEFAULTS.notificationChannels],
                fieldType: FieldType.Custom,
                rules: [{ required: true }],
                style: { marginTop: 0, marginBottom: 0 },
                extraFormItemProps: { hidden: true },
                renderField: () => <span aria-hidden />,
            },
            ...(checkboxActions?.slackChecked === false && checkboxActions?.emailChecked === false ?
                [createErrorField('Please select at least one notification channel')]
            :   []),
        );
    } else {
        channelFields.push({
            name: 'notificationChannels',
            initialValue: [...NOTIFICATION_FORM_DEFAULTS.notificationChannels],
            fieldType: FieldType.Custom,
            renderField: () => null,
            skipFormItemWrapper: true,
        });
    }

    if (inheritedChannelNames) {
        channelFields.push({
            name: 'usePrimaryChannels',
            initialValue: !!notification.usePrimaryChannels,
            fieldType: FieldType.Custom,
            style: { marginTop: 0, marginBottom: 0 },
            extraFormItemProps: { hidden: true },
            renderField: () => <span aria-hidden />,
        });
    }

    const mentionTypeField: FormFieldData = {
        name: 'mentionType',
        fieldType: FieldType.Custom,
        initialValue: selectedMentionType,
        skipFormItemWrapper: true,
        renderField: () => (
            <MentionTypeSelector
                isDisabled={isDisabled}
                isSelectionRequired={isSlackOptionRequired(SlackOption.Mentions)}
                getNotificationDestinationsState={getNotificationDestinationsState}
            />
        ),
    };

    const mentionReleasePilotField: FormFieldData = {
        label: '',
        name: 'mentionReleasePilot',
        fieldType: FieldType.Custom,
        initialValue: selectedMentionType === MentionType.ReleasePilot,
        extraFormItemProps: { hidden: true },
        renderField: () => null,
    };

    const channelsHelpMessage =
        hasProviderAndNotificationIntegration ?
            <>
                <Text type="secondary">
                    Pattern token strings are supported{' '}
                    <Popover
                        content={<PatternTokenHelperTextComponent availableTokens={CommsChannelAvailableTokens} />}
                    >
                        <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
                    </Popover>{' '}
                    <Tooltip title="If Runway cannot resolve selected tokens (e.g., no release name is set), the channel will not be created. Changing the release name or version during a release may disrupt notification delivery.">
                        <WarningFilled style={{ color: runwayColors.statusYellow, paddingLeft: 6 }} />
                    </Tooltip>
                </Text>
            </>
        :   <Text type="secondary">Notifications integration not installed.</Text>;

    const channelOptions = [
        ...availableChannels,
        ...notification.channels.filter(
            (selected) => !availableChannels.some((available) => available.id === selected.id),
        ),
    ];

    const isTeamsProvider = provider?.type === IntegrationProviderType.AzureActiveDirectory;
    const teamsProviderData = isTeamsProvider ? (provider?.data as AzureActiveDirectoryProviderData) : null;

    const channelsTooltipContent = (
        <div style={{ maxWidth: 400 }}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>
                    {`If the 'Create release-specific ${commsProviders}${' '} channel(s)' automation is enabled and a
                    tokenized channel name is configured, Runway will automatically create a new ${commsProviders}${' '}
                    channel(s) for releases according to the entered pattern.`}
                </li>
                {isSlackProvider && (
                    <li>
                        For private channels, you must first invite the Runway bot for Slack to the channel with the
                        @Runway command, then enter the channel ID (not name) as free text here.
                    </li>
                )}
            </ul>
        </div>
    );

    const channelsField = {
        label: (
            <span>
                Channel(s) override{' '}
                <Popover content={channelsTooltipContent} placement="top">
                    <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                </Popover>
            </span>
        ),
        name: 'channels',
        helpMessage: channelsHelpMessage,
        initialValue: notification.channels.map((chan) => chan.id),
        fieldType: FieldType.Custom,
        extraFormItemProps: {
            dependencies: ['notificationChannels'],
            style: { marginBottom: 0 },
        },
        rules: [
            ({ getFieldValue }) => ({
                validator: (_, values) => {
                    const currentChannels = getFieldValue('notificationChannels') || [];
                    const isSlackEnabled = hasProviderAndNotificationIntegration && currentChannels.includes('SLACK');
                    return isSlackEnabled ? commsChannelsValidatorFunction(provider.type, values) : Promise.resolve();
                },
            }),
            {
                validator: (_, values) =>
                    isSlackOptionRequired(SlackOption.Channels) && !(values?.length > 0) ?
                        Promise.reject(new Error('Select or enter at least one channel'))
                    :   Promise.resolve(),
            },
        ],
        data: channelOptions,
        renderField: (data, _, __, form) => {
            const { slack: isSlackEnabled } = getNotificationDestinationsState(form);
            const fieldDisabled = isDisabled || !hasProviderAndNotificationIntegration || !isSlackEnabled;

            if (isTeamsProvider && teamsProviderData) {
                return (
                    <TeamsChannelOverrideSelect
                        allChannels={availableChannels as MicrosoftTeamsChannel[]}
                        selectedChannels={notification.channels}
                        teams={teamsProviderData.availableTeams ?? []}
                        disabled={fieldDisabled}
                    />
                );
            }

            return (
                <Select
                    placeholder={'Select or enter channel(s)'}
                    mode="tags"
                    notFoundContent={null}
                    showSearch
                    allowClear
                    filterOption={filterOptionLabel}
                    disabled={fieldDisabled}
                >
                    {data.map((channel, index) => {
                        return (
                            <Select.Option value={channel.id} key={index} label={channel.name}>
                                {channel.name}
                            </Select.Option>
                        );
                    })}
                </Select>
            );
        },
    };

    const customCopyField: FormFieldData = {
        name: 'customCopy',
        initialValue: notification.customCopy ?? '',
        fieldType: FieldType.Custom,
        helpMessage: (
            <Text type="secondary">
                Type @ to mention a user or group. Pattern token strings are also supported.{' '}
                <Popover
                    content={
                        <div style={{ overflow: 'scroll', maxWidth: '40vw', maxHeight: '40vh' }}>
                            <PatternTokenHelperTextComponent availableTokens={AllPatternTokens} />
                        </div>
                    }
                    placement="top"
                >
                    <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                </Popover>
            </Text>
        ),
        extraFormItemProps: {
            validateTrigger: ['onBlur', 'onChange'],
            dependencies: ['notificationChannels'],
        },
        rules: [
            ...patternTokenSyntaxValidation(),
            {
                validator: (_, value) =>
                    isSlackOptionRequired(SlackOption.CustomText) && !value?.trim() ?
                        Promise.reject(new Error('Please enter custom copy to append'))
                    :   Promise.resolve(),
            },
        ],
        renderField: (data, _, __, form) => {
            const { slack: isSlackEnabled } = getNotificationDestinationsState(form);
            return (
                <MarkdownEditor
                    autoFocus={false}
                    allowMentions
                    allowPatternedStrings
                    users={appUsers}
                    userGroups={userGroups}
                    disabled={isDisabled || !hasProviderAndNotificationIntegration || !isSlackEnabled}
                />
            );
        },
    };

    channelFields.push({
        fieldType: FieldType.WrappedGroup,
        groupedFields: [
            mentionTypeField,
            mentionedGroupsField,
            mentionedUsersField,
            mentionReleasePilotField,
            channelsField,
            customCopyField,
        ],
        groupChildrenWrapper: (children) => {
            return (
                <NotificationChannelSection
                    title={notificationsChannelTitle}
                    icon={
                        <IntegrationIcon
                            integrationId={isTeamsProvider ? IntegrationType.MicrosoftTeams : IntegrationType.Slack}
                        />
                    }
                    isChecked={notification.allowEmails ? (checkboxActions?.slackChecked ?? true) : undefined}
                    onToggle={
                        notification.allowEmails ?
                            (checked) =>
                                checkboxActions?.handleChannelCheckboxChange(NotificationDestination.Slack, checked)
                        :   undefined
                    }
                    disabled={isDisabled}
                    headerAction={checkboxActions?.slackHeaderAction}
                >
                    {slackOptions ?
                        <Flex vertical gap={12}>
                            <Radio.Group
                                value={
                                    slackOptions[SlackOption.Channels].checked ? 'custom'
                                    : checkboxActions?.usePrimaryChannels ?
                                        'primary'
                                    :   'default'
                                }
                                onChange={(event) => checkboxActions?.onChannelModeChange(event.target.value)}
                                disabled={optionsDisabled}
                            >
                                <Flex vertical gap={12}>
                                    <ChannelModeRadio
                                        value={
                                            inheritedChannelNames?.length || checkboxActions?.usePrimaryChannels ?
                                                'primary'
                                            :   'default'
                                        }
                                        label="Send to default primary channel(s):"
                                        channelNames={primaryChannels ?? []}
                                    />
                                    {!!inheritedChannelNames?.length && (
                                        <ChannelModeRadio
                                            value="default"
                                            label="Send to app-level channel(s):"
                                            channelNames={inheritedChannelNames}
                                        />
                                    )}
                                    <Radio value="custom">Customize channel(s) to send to</Radio>
                                </Flex>
                            </Radio.Group>
                            <div
                                style={{
                                    display: slackOptions[SlackOption.Channels].checked ? 'block' : 'none',
                                    paddingLeft: 24,
                                }}
                            >
                                {renderFormFields([channelsField])}
                            </div>
                            <Divider style={{ margin: '8px 0', borderColor: antGrey.grey5 }} />
                            <ChannelOptionToggle
                                label="Mention (@) individual users or user groups"
                                checked={slackOptions[SlackOption.Mentions].checked}
                                onChange={slackOptions[SlackOption.Mentions].onChange}
                                disabled={optionsDisabled}
                            >
                                {renderFormFields([
                                    mentionTypeField,
                                    mentionedGroupsField,
                                    mentionedUsersField,
                                    mentionReleasePilotField,
                                ])}
                            </ChannelOptionToggle>
                            <ChannelOptionToggle
                                label="Append custom text"
                                checked={slackOptions[SlackOption.CustomText].checked}
                                onChange={slackOptions[SlackOption.CustomText].onChange}
                                disabled={optionsDisabled}
                            >
                                {renderFormFields([customCopyField])}
                            </ChannelOptionToggle>
                        </Flex>
                    :   children}
                </NotificationChannelSection>
            );
        },
    });

    if (notification.allowEmails) {
        const emailField = {
            label: 'Recipients',
            name: 'emailsToInclude',
            helpMessage: 'Enter one or more email addresses to receive this type of notification via email.',
            initialValue: notification.emailsToInclude || [],
            fieldType: FieldType.Custom,
            extraFormItemProps: {
                dependencies: ['notificationChannels'],
            },
            rules: emailValidationRules([], !isDisabled && checkboxActions?.emailChecked === true),
            data: notification.emailsToInclude || [],
            renderField: (data, _, __, form) => {
                const { email: isEmailEnabled } = getNotificationDestinationsState(form);

                return (
                    <Select
                        placeholder="Enter email addresses"
                        mode="tags"
                        notFoundContent={null}
                        showSearch
                        allowClear
                        tokenSeparators={[',']}
                        disabled={isDisabled || !isEmailEnabled}
                    >
                        {data.map((email, index) => {
                            return (
                                <Select.Option value={email} key={index}>
                                    {email}
                                </Select.Option>
                            );
                        })}
                    </Select>
                );
            },
        };

        channelFields.push({
            fieldType: FieldType.WrappedGroup,
            groupedFields: [emailField],
            groupChildrenWrapper: (children) => (
                <NotificationChannelSection
                    title="Email notifications"
                    icon={<MailOutlined style={{ fontSize: 16, color: runwayColors.primary }} />}
                    isChecked={checkboxActions?.emailChecked ?? false}
                    onToggle={(checked) =>
                        checkboxActions?.handleChannelCheckboxChange(NotificationDestination.Email, checked)
                    }
                    disabled={isDisabled}
                >
                    {children}
                </NotificationChannelSection>
            ),
        });
    }

    return { enabled: enabledField, settings: fields, channels: channelFields, triggers: triggerFields };
};

// Definitions are shared by the app and its overrides, so each pane fills in its own saved value
const withNotificationCurrentValue = (settingField: SettingField, notification: CommonNotification): SettingField => {
    const currentValue = notification[settingField.key];
    return isUnsetValue(currentValue) ? settingField : { ...settingField, currentValue };
};

// Disabling sits outside the form items, since antd hands each item's value to its direct child
const withNotificationFieldsDisabled = (formFields: FormFieldData[], isDisabled: boolean): FormFieldData[] =>
    formFields.length === 0 ?
        []
    :   [
            {
                fieldType: FieldType.WrappedGroup,
                groupedFields: formFields,
                groupChildrenWrapper: (children) => (
                    <ConfigProvider componentDisabled={isDisabled || undefined}>{children}</ConfigProvider>
                ),
            },
        ];

// Condition groups need the app's monitoring settings and integrations, which the shared renderer doesn't have
const resolveNotificationFormField = (
    settingField: SettingField,
    healthContext: HealthConditionGroupsContext,
): FormFieldData | undefined =>
    settingField.type === SettingFieldType.ConditionGroups ?
        buildHealthConditionGroupsField(settingField, healthContext)
    :   undefined;

type HealthConditionGroupsContext = Pick<
    NotificationFormFieldsProps,
    | 'notification'
    | 'connectedCapabilities'
    | 'stabilityIntegrations'
    | 'appStoreType'
    | 'maxRolloutDay'
    | 'monitoringMetrics'
    | 'healthMetricsLink'
>;

// Shared with the halt automation's editor; its choices depend on the app's store and stability integrations
const buildHealthConditionGroupsField = (
    settingField: SettingField,
    healthContext: HealthConditionGroupsContext,
): FormFieldData => {
    const { notification, appStoreType, maxRolloutDay, stabilityIntegrations } = healthContext;
    const gateConditionTypes = automationConditionsForAutomationType(
        AutomationType.AutoHaltUnstablePhasedReleases,
        appStoreType,
    );
    const monitoringConditionOptions: MonitoringConditionOption[] = gateConditionTypes.map((type) => ({
        id: type,
        title: displayTextForAutomationConditionType(type),
    }));

    const rolloutNoun = rolloutNounForAppStoreType(appStoreType);
    const rolloutDayTriggerOption: NotificationTriggerOption = {
        id: NotificationTriggerConditionType.RolloutDay,
        title: displayTextForNotificationTriggerConditionType(
            NotificationTriggerConditionType.RolloutDay,
            appStoreType,
        ),
        input: { min: 1, max: maxRolloutDay, precision: 0, descriptionText: `${rolloutNoun} day` },
    };
    const rolloutPercentageTriggerOption: NotificationTriggerOption = {
        id: NotificationTriggerConditionType.RolloutPercentage,
        title: displayTextForNotificationTriggerConditionType(
            NotificationTriggerConditionType.RolloutPercentage,
            appStoreType,
        ),
        input: { min: 1, max: 100, precision: 0, addonAfter: '%', descriptionText: `${rolloutNoun} percentage` },
    };
    const triggerOptions: NotificationTriggerOption[] = [
        ...(gateConditionTypes.includes(MonitoringAutomationConditionType.PhasedReleaseDay) ?
            [rolloutPercentageTriggerOption]
        : gateConditionTypes.includes(MonitoringAutomationConditionType.StagedRolloutPercentage) ?
            [rolloutDayTriggerOption]
        :   []),
        {
            id: NotificationTriggerConditionType.PreviousReleaseFullyRolledOut,
            title: displayTextForNotificationTriggerConditionType(
                NotificationTriggerConditionType.PreviousReleaseFullyRolledOut,
            ),
        },
    ];

    return generateHaltPhasedRolloutConditionGroupsField(
        notification.conditionGroups?.length ?
            notification.conditionGroups
        :   legacyThresholdsAsConditionGroups(notification, stabilityIntegrations),
        healthContext.connectedCapabilities,
        monitoringConditionOptions,
        healthContext.monitoringMetrics,
        healthContext.healthMetricsLink,
        stabilityIntegrations,
        settingField.label,
        triggerOptions,
        'notification',
    );
};
